import React, { Component } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import MultiSelect from "react-multi-select-component";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import simulationandtrain from "../../../assets/create_campaign/simulationandtrain.png";
import customSwal from "../../../customSwal";
import {
	PiXThin,
	PiTrash,
	PiChartLine,
	PiUsers,
	PiListBullets,
	PiWarning,
	PiShield,
	PiHeart,
	PiTimerLight,
	PiFileText,
	PiArrowClockwiseLight,
	PiCircleFill,
	PiPencilSimple,
	PiCheck,
	PiX,
	PiEye,
	PiBookOpen
} from "react-icons/pi";
import {
	Nav,
	Button,
	Card,
	InputGroup,
	FormControl,
	Dropdown,
	OverlayTrigger,
	Tooltip,
	Badge,
	Alert,
	Tabs,
	Tab
} from "react-bootstrap";
import Loader from "../../../component/loader/loader";
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import Total from "../../../component/campaigns/charts/total";
import Replied from "../../../component/campaigns/charts/replied";
import SMSSend from "../../../component/campaigns/charts/sms-send";
import EmailSend from "../../../component/campaigns/charts/email-send";
import SystemHack from "../../../component/campaigns/charts/system-hack";
import CallPicked from "../../../component/campaigns/charts/call-picked";
import MessageSent from "../../../component/campaigns/charts/message-send";
import EmailOpened from "../../../component/campaigns/charts/email-opened";
import LinkClicked from "../../../component/campaigns/charts/link-clicked";
import DataSubmitted from "../../../component/campaigns/charts/data-submitted";
import EmailReported from "../../../component/campaigns/charts/email-reported";
import CallInitiated from "../../../component/campaigns/charts/call-initiated";
import DetailModal from "../../../component/campaigns/detail-modal/detail-modal";
import AttachmentOpened from "../../../component/campaigns/charts/attachment-opened";
import axiosRequest from "axios";
import axios from "../../../axios";
import apiError from "../../../error";
import { getDate, getDateWithoutTime } from "../../../function"
import "./campaign.css";
import CampaignPreview from "../../../component/create-template/campaign-preview/campaign-preview";
import { IoInformation } from "react-icons/io5";
import CallReceived from "../../../component/campaigns/charts/call-received";
import AiVishingMinuteConsumption from "../../../component/ai-vishing-minute-consumption/ai-vishing-minute-consumption";
import { TfiPlus } from "react-icons/tfi";
import FollowUpCampaignModal from "../../../component/launch-modal/follow-up-campaign-modal";
import ActivityDrawer from "../../../component/campaigns/activity-drawer";
import ByTemplateModal from "../../../component/campaigns/by-template-modal";
import { getUserActivityStatusBadgeProps } from "../../../component/campaigns/user-activity-status-badge";
import { getByTemplateStatFields, getOverviewIconMeta } from "../../../component/campaigns/campaign-overview";

var cancelRequest = undefined,
	CancelToken = axiosRequest.CancelToken;

const FILE_TYPE_FILTER_WINDOWS = "windows";
const FILE_TYPE_FILTER_MAC = "mac";

/** Add new file types here; filter UI and labels pick them up automatically. */
const FILE_TYPE_FILTER_OPTIONS = [
	{ value: FILE_TYPE_FILTER_WINDOWS, label: "Windows" },
	{ value: FILE_TYPE_FILTER_MAC, label: "Mac" },
];

// const FILTER_DUMMY_IP_OPTIONS = [
// 	{ label: '192.168.1.1', value: '192.168.1.1' },
// 	{ label: '192.168.1.2', value: '192.168.1.2' },
// 	{ label: '10.0.0.1', value: '10.0.0.1' },
// 	{ label: '10.0.0.2', value: '10.0.0.2' },
// 	{ label: '172.16.0.1', value: '172.16.0.1' }
// ];
// Match campaign-list health meter: solid dark green/red (>= 80% / < 80%), normalized percent.
const HEALTH_DOT_GREEN_DARK = "#169c17";
const HEALTH_DOT_RED_DARK = "#b71c1c";

const normalizeCampaignHealthPercent = (raw) => {
	if (raw === null || raw === undefined || raw === "") return null;
	const n = Number.parseFloat(String(raw).replace(/%/g, "").trim());
	if (!Number.isFinite(n)) return null;
	if (n > 0 && n < 1) return Math.round(n * 100);
	return Math.max(0, Math.min(100, Math.round(n)));
};

const hasCustomExpiryTime = (raw) => {
	const s = String(raw ?? "").trim();
	if (!s) return false;
	const timeMatch = s.match(/T(\d{2}):(\d{2})/);
	if (!timeMatch) return false;
	return (
		parseInt(timeMatch[1], 10) !== 0 || parseInt(timeMatch[2], 10) !== 0
	);
};

/** User's launch choice: 7, 15, or custom (for Campaign Duration only). */
const getCampaignExpiryChoice = (details, completesOn) => {
	const expiryDaysRaw =
		details?.expiryDays ??
		details?.campaign?.expiryDays ??
		details?.campaign?.expiry_days;
	if (String(expiryDaysRaw).toLowerCase() === "custom") {
		return "custom";
	}
	const expiryDaysNum = parseInt(expiryDaysRaw, 10);
	if (expiryDaysNum === 7) return 7;
	if (expiryDaysNum === 15) return 15;

	const campaignExpiry =
		details?.campaignExpiry ?? details?.campaign?.campaignExpiry;
	if (hasCustomExpiryTime(campaignExpiry)) {
		return "custom";
	}

	const scheduled = details?.scheduledAt;
	const endRaw = completesOn ?? details?.completesOn;
	if (scheduled && endRaw) {
		const start = new Date(scheduled);
		const end = new Date(endRaw);
		if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
			const diffDays = Math.round(
				(end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
			);
			if (diffDays >= 6 && diffDays <= 8) return 7;
			if (diffDays >= 14 && diffDays <= 16) return 15;
			return "custom";
		}
	}

	return null;
};

const formatCampaignDurationForEdit = (details, completesOn) => {
	const choice = getCampaignExpiryChoice(details, completesOn);
	if (choice === "custom") return "Custom";
	if (choice === 7) return "7 days";
	if (choice === 15) return "15 days";
	return "—";
};

/** Campaign Expiry: always show expiry date and time. */
const formatCampaignExpiryForEdit = (details, completesOn) => {
	const raw =
		completesOn ??
		details?.completesOn ??
		details?.campaignExpiry ??
		details?.campaign?.campaignExpiry ??
		null;
	if (raw == null || raw === "") return "—";

	const rawStr = String(raw).trim();
	const parsed = new Date(rawStr.includes("T") ? rawStr : rawStr.replace(" ", "T"));
	if (isNaN(parsed.getTime())) return rawStr;

	const pad = (n) => String(n).padStart(2, "0");
	const monthName = parsed.toLocaleString("en-US", { month: "long" });
	const day = pad(parsed.getDate());
	const year = parsed.getFullYear();
	let hours = parsed.getHours();
	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12 || 12;

	return `${day} ${monthName} ${year} | ${hours}:${pad(parsed.getMinutes())} ${ampm}`;
};

/**
 * Header campaign badge: any simulation "In Progress" → In Progress; else any "Scheduled" → Scheduled; else Completed.
 */
const aggregateCampaignStatusFromSimulations = (simulations) => {
	if (!Array.isArray(simulations) || simulations.length === 0) return null;
	const normalized = simulations.map((s) =>
		String(s?.simulationStatus ?? "")
			.trim()
			.toLowerCase()
	);
	if (normalized.some((st) => st === "in progress")) return "In Progress";
	if (normalized.some((st) => st === "scheduled")) return "Scheduled";
	return "Completed";
};


export default class CampaignEdit extends Component {
	userHasSelectedTab = false;
	/** After first `/api/simulation/` load succeeded; later refreshes defer template fields until it returns again (avoids chart flicker vs stale `status`). */
	_simulationMetricsLoaded = false;
	/** While true, `getDetails` skips updating fields that must stay aligned with `status` from `loadTotal`. */
	_deferChartMetaFromDetails = false;
	/** Set when API returns the new simulation id; validated against refreshed `simulations`. */
	_followUpCreatedSimulationId = null;
	/** Snapshot of simulation ids before follow-up launch; used to find the newly created id by diff. */
	_followUpPrevSimulationIds = null;
	/** Retries left for `getDetails` to find the new follow-up simulation (backend can lag briefly after create). */
	_followUpRetriesLeft = 0;
	_followUpRetryTimer = null;
	/** Bumped on every `getDetails`/`loadTotal` call; a response only applies if it's still the latest —
		otherwise switching tabs quickly (before the previous tab's request settles) can let a slower,
		stale response land after the newer one and overwrite it with the wrong tab's data. */
	_detailsSeq = 0;
	_totalSeq = 0;

	constructor(props) {
		super(props);
		const listHealth = props.location?.state?.campaignListHealth;
		const campaignHealthFromList =
			listHealth != null && listHealth !== "" && String(listHealth).trim() !== "" ? listHealth : null;
		this.state = {
			count: 0,
			limit: 10,
			value: [],
			status: {},
			search: "",
			message: {},
			results: [],
			key: "all",
			myTemplates: [],
			byTemplateModalOpen: false,
			byTemplateModalTemplate: null,
			details: {},
			groupName: [],
			groupIds: [],
			category: [],
			activity: "",
			loading: true,
			activePage: 1,
			attackType: "",
			targetInteractionType: "",
			/** WhatsApp AI conversational vs direct (from campaign template) */
			isAIbased: false,
			simulationType: "",
			credentialHarvesting: false,
			incedent: 0,
			expired: '',
			activeId: null,
			breachTime: 0,
			detailModal: false,
			expiredProgress: 0,
			primaryCampaignFollowUpEnabled: false,
			statusFilter: "all",
			simulationError: false,
			disabledClosedBtn: false,
			isRepliedCampaign: false,
			campaignId: parseInt(this.props.match.params.campaignId, 10),
			simulationId: parseInt(this.props.match.params.simulationId, 10),
			showPreview: false,
			campaignType: null,
			campaignTemplateId: null,
			ips: [],
			selectedIps: [],
			lmsUrl: null,
			trainingSummary: null,
			trainingSummaryCourses: [],
			trainingSummaryLoading: false,
			trainingImageURL: "",
			trainingPreviewURL: "",
			completesOn: null,
			// Same unit as simulation.id — used to highlight the simulation tab (not a list index).
			activeTabFilter: parseInt(this.props.match.params.simulationId, 10),
			showFollowUpModal: false,
			/** True from the moment a follow-up campaign is created until its tab shows up (see handleFollowUpSuccess). */
			followUpTabLoading: false,
			activeAnalyticsTab: 'campaign-analytics',
			showCreateGroupModal: false,
			userDetailsFilterPanelOpen: false,
			userDetailsFilterTab: 'activity',
			filterDraftActivity: 'all',
			filterDraftIps: [],
			fileTypeFilter: 'all',
			filterDraftFileType: 'all',
			activityDrawerOpen: false,
			activityDrawerUser: null,
			createGroupSubmenuOpen: false,
			actionDropdownOpen: false,
			createdAt: null,
			followUpCampaign: null,
			launchDate: null,
			scheduledAt: null,
			userCount: null,
			groupCount: null,
			instantAwareness: null,
			userReplyConfiguration: null,
			phishRate: null,
			clickRate: null,
			industryRisk: null,
			avgScore: null,
			healthScore: null,
			/** Campaign-wide aggregate health for header (`campaign.health`). Remaining Health card uses `healthScore` (per active simulation). */
			campaignHealthForHeader: campaignHealthFromList,
			followUpCondition: null,
			parentSimulationId: null,
			/** From GET /api/simulation/ (`simulation.isScheduled`). When 0/false, hide Scheduled Date in campaign details. */
			simulationIsScheduled: null,
			/** True while refresh button waits for details + dependent simulation/analytics requests */
			headerRefreshLoading: false,
			/** Inline header: rename campaign */
			editingCampaignName: false,
			campaignNameDraft: "",
			campaignNameSaveLoading: false,
			campaignNameInputError: "",

		};
	}

	componentDidMount = () => {
		this.userHasSelectedTab = false;
		if (this.state.simulationId) {
			this.prepareRefresh();
			this.getDetails();
		} else this.getSimulationId();
	};

	componentWillUnmount() {
		if (this._followUpRetryTimer) {
			clearTimeout(this._followUpRetryTimer);
			this._followUpRetryTimer = null;
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.campaignId !== this.props.match.params.campaignId) {
			this.userHasSelectedTab = false;
			this._simulationMetricsLoaded = false;
			this._deferChartMetaFromDetails = false;
			this._followUpCreatedSimulationId = null;
			this._followUpPrevSimulationIds = null;
			this._followUpRetriesLeft = 0;
			if (this._followUpRetryTimer) {
				clearTimeout(this._followUpRetryTimer);
				this._followUpRetryTimer = null;
			}

			const newCampaignId = parseInt(this.props.match.params.campaignId, 10);
			const newSimulationId = parseInt(this.props.match.params.simulationId, 10) || 0;

			this.setState({
				campaignId: newCampaignId,
				simulationId: newSimulationId,
				activeTabFilter: newSimulationId,
				campaignHealthForHeader: null,
				simulationIsScheduled: null,
				editingCampaignName: false,
				campaignNameDraft: "",
				campaignNameInputError: "",
			}, () => {
				if (newSimulationId) {
					this.prepareRefresh();
					this.getDetails();
				} else {
					this.getSimulationId();
				}
			});
		}
	}



	secondsToHms = (d) => {
		d = Number(d);
		var h = Math.floor(d / 3600);
		var m = Math.floor((d % 3600) / 60);
		var s = Math.floor((d % 3600) % 60);

		var hDisplay = h > 0 ? (h < 10 ? "0" : "") + h + " : " : "00 : ";
		var mDisplay = m > 0 ? (m < 10 ? "0" : "") + m + " : " : "00 : ";
		var sDisplay = s > 0 ? (s < 10 ? "0" : "") + s + "" : "00";
		return hDisplay + mDisplay + sDisplay;
	};

	renderUserActivityStatusBadge = (status) => {
		const { label, className } = getUserActivityStatusBadgeProps(status);
		return <Badge className={className}>{label}</Badge>;
	};

	// days_between = (date1, date2, Expired) => {
	// 	const ONE_DAY = 1000 * 60 * 60 * 24;
	// 	const differenceMs = Math.abs(date1 - date2);
	// 	var day = differenceMs / ONE_DAY;
	// 	day = day > 7 ? 100 : (day * 100) / Expired;
	// 	day = day > 100 ? 100 : day;
	// 	if(day<15) day = 15;
	// 	return day;
	// };

	compute_days = (date1, date2) => {
		const ONE_DAY = 1000 * 60 * 60 * 24;
		if (date1 < date2) {
			return 0;
		}
		const differenceMs = Math.abs(date1 - date2);
		return Math.ceil(differenceMs / ONE_DAY);
	}

	completion_percentage = (currDate, createdDate, expiryDate) => {
		const totalDays = this.compute_days(expiryDate, createdDate);
		const elapsedDays = Math.max(0, Math.min(this.compute_days(currDate, createdDate), totalDays));
		return Math.max(15, Math.round((elapsedDays / totalDays) * 100));
	}

	/** Normalize instant-awareness from API (boolean, 0/1, "true"/"false"). */
	coerceInstantAwareness = (raw) => {
		if (raw === true || raw === false) return raw;
		if (raw === 1 || raw === 0) return raw === 1;
		if (typeof raw === "string") {
			const s = String(raw).trim().toLowerCase();
			if (s === "true" || s === "1") return true;
			if (s === "false" || s === "0") return false;
		}
		return undefined;
	};

	/** Normalize credential harvesting from API (boolean, 0/1, strings; avoid !!\"false\" === true). */
	coerceCredentialHarvesting = (raw) => {
		if (raw === true || raw === false) return raw;
		if (raw === 1 || raw === 0) return raw === 1;
		if (typeof raw === "string") {
			const s = String(raw).trim().toLowerCase();
			if (s === "true" || s === "1" || s === "yes" || s === "on") return true;
			if (s === "false" || s === "0" || s === "no" || s === "off" || s === "") return false;
		}
		return undefined;
	};

	pickCredentialHarvestingRaw = (obj) => {
		if (!obj || typeof obj !== "object") return undefined;
		return obj.credential_harvesting ?? obj.credentialHarvesting;
	};

	pickInstantAwarenessFromDetails = (details, assignTemplate) => {
		const c = details?.campaign;
		const ct = assignTemplate?.campaign_template;
		const raw =
			c?.isInstantAwareness ??
			c?.instantAwareness ??
			c?.is_instant_awareness ??
			c?.instant_awareness ??
			details?.isInstantAwareness ??
			details?.instantAwareness ??
			details?.is_instant_awareness ??
			details?.instant_awareness ??
			assignTemplate?.isInstantAwareness ??
			assignTemplate?.instantAwareness ??
			assignTemplate?.is_instant_awareness ??
			assignTemplate?.instant_awareness ??
			ct?.isInstantAwareness ??
			ct?.instantAwareness ??
			ct?.is_instant_awareness ??
			ct?.instant_awareness;
		return this.coerceInstantAwareness(raw);
	};

	pickInstantAwarenessFromSimulation = (simulation, campaign) => {
		const raw =
			simulation?.isInstantAwareness ??
			simulation?.instantAwareness ??
			simulation?.is_instant_awareness ??
			simulation?.instant_awareness ??
			campaign?.isInstantAwareness ??
			campaign?.instantAwareness ??
			campaign?.is_instant_awareness ??
			campaign?.instant_awareness;
		return this.coerceInstantAwareness(raw);
	};

	getSimulationId = () => {
		if (!this.state.simulationId) {
			axios
				.get("/api/simulation/simulationId", {
					params: { campaignId: this.state.campaignId },
				})
				.then((res) => {
					this.setState({ simulationId: res.data.simulationId, loading: false }, () => {
						this.prepareRefresh();
						this.getDetails();
					});
				})
				.catch(() => {
					setTimeout(() => {
						this.getSimulationId();
					}, 3000);
				});
		} else {
			this.prepareRefresh();
			this.getDetails();
		}
	};

	prepareRefresh = () => {
		if (this._simulationMetricsLoaded) {
			this._deferChartMetaFromDetails = true;
		}
		this.setState({ simulationError: false });
	};

	getDetails = () => {
		// Details API must use the same simulation as the active tab (highlighted list item).
		const activeTabId = Number(this.state.activeTabFilter);
		const stateSimId = parseInt(this.state.simulationId, 10);
		const simulationIdForApi =
			Number.isFinite(activeTabId) && activeTabId > 0
				? activeTabId
				: !Number.isNaN(stateSimId) && stateSimId > 0
					? stateSimId
					: stateSimId;

		// Captured now (not read from `this._deferChartMetaFromDetails` when the response lands) so a
		// later tab click's `prepareRefresh()` — which runs before this request's response arrives —
		// can't retroactively change whether THIS response defers its chart-meta fields.
		const deferChartMeta = this._deferChartMetaFromDetails;
		const detailsSeq = ++this._detailsSeq;

		axios
			.get("/api/campaigns/details", {
				params: { campaignId: this.state.campaignId, simulationId: simulationIdForApi },
			})
			.then((res) => {
				// A newer getDetails() call has since started (e.g. the user clicked another tab before
				// this request settled) — its own response is authoritative, so drop this stale one
				// instead of letting it overwrite state for a tab that's no longer selected.
				if (detailsSeq !== this._detailsSeq) return;
				var expiredProgress = this.completion_percentage(new Date(), new Date(res.data.details.scheduledAt), new Date(res.data.details.completedAt));
				const details = res.data.details;
				const assignTemplates = details?.campaign?.assign_templates ?? details?.assign_templates;
				const assignTemplate = Array.isArray(assignTemplates) && assignTemplates.length > 0
					? assignTemplates[0]
					: null;
				const campaignTemplate = assignTemplate?.campaign_template;
				// Simulation type + credential harvesting are read from the simulation now.
				const simulationType = (details?.simulation_type?.name || "").trim();
				const chFromSimulation = this.coerceCredentialHarvesting(
					this.pickCredentialHarvestingRaw(details)
				);
				const credentialHarvesting = chFromSimulation !== undefined ? chFromSimulation : false;
				let attackType = (campaignTemplate?.attack_type?.name || "").trim();
				let targetInteractionType = (campaignTemplate?.targetInteractionType || "").trim();
				if (!attackType && Array.isArray(assignTemplates)) {
					const withAttack = assignTemplates.find((a) => a?.campaign_template?.attack_type?.name);
					attackType = (withAttack?.campaign_template?.attack_type?.name || "").trim();
				}
				const simulations = details?.campaign?.simulations ?? [];
				const primarySim = simulations.find(
					(s) => String(s?.name ?? "").trim().toLowerCase() === "primary campaign"
				);
				const primaryCampaignFollowUpEnabled = Boolean(
					primarySim &&
					primarySim.completedAt != null &&
					new Date(primarySim.completedAt).getTime() < Date.now()
				);
				const firstSim = simulations[0];
				const firstSimId = firstSim?.id != null ? parseInt(firstSim.id, 10) : null;
				const currentSimId = simulationIdForApi;
				const currentIdx = simulations.findIndex((s) => parseInt(s?.id, 10) === currentSimId);
				// On page load, default to simulations[0] (first tab). After user clicks another tab, keep their selection.
				const defaultToFirstOnLoad = firstSimId != null && !this.userHasSelectedTab;
				let activeTabFilter = 0;
				let nextSimulationId = null;
				if (defaultToFirstOnLoad) {
					activeTabFilter = firstSimId;
					nextSimulationId = firstSimId;
				} else if (currentIdx >= 0 && simulations[currentIdx]?.id != null) {
					activeTabFilter = parseInt(simulations[currentIdx].id, 10);
				} else if (!isNaN(currentSimId) && currentSimId > 0) {
					activeTabFilter = currentSimId;
				} else if (firstSimId != null) {
					activeTabFilter = firstSimId;
				}
				// After follow-up: select the simulation we just created (API id if valid, else id that appeared since pre-launch snapshot).
				const expectedFollowUpId = this._followUpCreatedSimulationId;
				const prevSimIdSet = this._followUpPrevSimulationIds;
				const awaitingFollowUp = expectedFollowUpId != null || prevSimIdSet != null;
				let createdFollowUpSimId = null;
				if (expectedFollowUpId != null) {
					const tid = parseInt(expectedFollowUpId, 10);
					if (Number.isFinite(tid) && tid > 0 && simulations.some((s) => parseInt(s?.id, 10) === tid)) {
						createdFollowUpSimId = tid;
					}
				}
				if (createdFollowUpSimId == null && prevSimIdSet) {
					const currentIds = simulations
						.map((s) => (s?.id != null ? parseInt(s.id, 10) : NaN))
						.filter((n) => Number.isFinite(n) && n > 0);
					const createdIds = currentIds.filter((id) => !prevSimIdSet.has(id));
					if (createdIds.length === 1) {
						createdFollowUpSimId = createdIds[0];
					} else if (createdIds.length > 1) {
						createdFollowUpSimId = Math.max(...createdIds);
					}
				}
				// Once true, the follow-up loader (state.followUpTabLoading) can come off — either
				// the new tab was found, or we're out of retries and giving up on this response.
				let followUpSettled = false;
				if (createdFollowUpSimId != null) {
					activeTabFilter = createdFollowUpSimId;
					nextSimulationId = createdFollowUpSimId;
					this._followUpCreatedSimulationId = null;
					this._followUpPrevSimulationIds = null;
					this._followUpRetriesLeft = 0;
					followUpSettled = true;
				} else if (awaitingFollowUp) {
					// The new simulation isn't in this response yet — the backend can lag briefly
					// right after create. Keep watching (don't clear the tracking refs) and retry
					// shortly instead of leaving the follow-up tab missing until the next reload.
					if (this._followUpRetriesLeft > 0) {
						this._followUpRetriesLeft -= 1;
						if (this._followUpRetryTimer) clearTimeout(this._followUpRetryTimer);
						this._followUpRetryTimer = setTimeout(() => {
							this._followUpRetryTimer = null;
							this.getDetails();
						}, 1200);
					} else {
						this._followUpCreatedSimulationId = null;
						this._followUpPrevSimulationIds = null;
						followUpSettled = true;
					}
				}
				const campaignHealthFromDetails = res.data.overallHealth;
				const prevHeaderHealth = this.state.campaignHealthForHeader;
				const instantAwarenessFromDetails = (() => {
					const picked = this.pickInstantAwarenessFromDetails(details, assignTemplate);
					return picked !== undefined ? picked : this.state.instantAwareness;
				})();
				const isAIbasedFromTemplate =
					campaignTemplate != null &&
					(campaignTemplate.isAIbased === true ||
						campaignTemplate.isAIbased === 1 ||
						String(campaignTemplate.isAIbased).toLowerCase() === "true");
				const stateUpdate = {
					lmsUrl: res.data.lmsUrl,
					trainingSummary: details?.trainingSummary || null,
					expired: res.data.Expired,
					details,
					activeTabFilter,
					expiredProgress: expiredProgress,
					primaryCampaignFollowUpEnabled,
					groupName: details?.campaign?.campaign_groups,
					groupIds: details?.campaign?.campaign_groups?.map(item => item.groupId),
					isAIbased: isAIbasedFromTemplate,
					...(deferChartMeta
						? {}
						: {
							simulationType,
							credentialHarvesting,
							attackType: attackType || this.state.attackType,
							targetInteractionType: targetInteractionType || this.state.targetInteractionType,
							instantAwareness: instantAwarenessFromDetails,
						}),
					createdAt: details?.createdAt,
					followUpCampaign: details?.campaign?.simulations?.length,
					launchDate: details?.scheduledAt,
					scheduledAt: details?.scheduledAt || details?.launchDate,
					groupCount: details?.groupCount,
					userReplyConfiguration: details?.isRepliedCampaign,
					campaignHealthForHeader: res.data.overallHealth,
				};
				if (nextSimulationId != null) stateUpdate.simulationId = nextSimulationId;
				if (followUpSettled) stateUpdate.followUpTabLoading = false;
				this.setState(stateUpdate, () => {
					// If we default the active tab to a different id than this request used, fetch details again for that simulation.
					if (nextSimulationId != null && nextSimulationId !== simulationIdForApi) {
						this.getDetails();
						return;
					}
					Promise.resolve(this.loadSimulationDataAsync())
						.catch(() => { })
						.finally(() => {
							this.setState((prev) =>
								prev.headerRefreshLoading ? { headerRefreshLoading: false } : null
							);
						});
				});
			})
			.catch((error) => {
				if (detailsSeq !== this._detailsSeq) return;
				this._deferChartMetaFromDetails = false;
				this._followUpCreatedSimulationId = null;
				this._followUpPrevSimulationIds = null;
				this._followUpRetriesLeft = 0;
				apiError(error);
				this.setState((prev) => ({
					...(prev.headerRefreshLoading ? { headerRefreshLoading: false } : {}),
					...(prev.followUpTabLoading ? { followUpTabLoading: false } : {}),
				}));
			});
	};

	loadIps = () => {
		return axios
			.get("/api/results/ips", {
				params: { simulationId: this.state.simulationId },
			})
			.then((res) => {
				this.setState({ ips: res.data.ips });
			})
			.catch((error) => apiError(error));
	};

	handleRefresh = () => {
		if (this.state.headerRefreshLoading) {
			return;
		}
		if (this._simulationMetricsLoaded) {
			this._deferChartMetaFromDetails = true;
		}
		this.setState({ simulationError: false, headerRefreshLoading: true });
		this.getDetails();
		if (this.state.key === "by-templates") {
			this.handleMyTemplates();
		}
		if (this.state.activeAnalyticsTab === "training-summary") {
			this.loadTrainingSummary();
		}
	};

	/** After creating a follow-up, switch to that simulation tab and reload details/analytics. */
	handleFollowUpSuccess = (res) => {
		const d = res?.data;
		const root = d && typeof d === "object" && d.data && typeof d.data === "object" ? d.data : d;
		let newSimId = null;
		if (root && typeof root === "object") {
			const tryParse = (v) => {
				const n = parseInt(v, 10);
				return Number.isFinite(n) && n > 0 ? n : null;
			};
			newSimId =
				tryParse(root.simulationId) ??
				tryParse(root.newSimulationId) ??
				tryParse(root.new_simulation_id) ??
				tryParse(root.simulation?.id) ??
				tryParse(root.simulation?.simulationId) ??
				tryParse(root.id) ??
				null;
		}

		const prevSims = this.state.details?.campaign?.simulations ?? [];
		this._followUpPrevSimulationIds = new Set(
			prevSims
				.map((s) => (s?.id != null ? parseInt(s.id, 10) : NaN))
				.filter((n) => Number.isFinite(n) && n > 0)
		);
		// The backend can take a beat to make the new simulation visible on
		// `campaign.simulations` right after create, so give getDetails a few
		// retries before giving up — otherwise the follow-up tab only shows up
		// after the user leaves and comes back to this page.
		this._followUpRetriesLeft = 4;

		this.setState({ showFollowUpModal: false, followUpTabLoading: true }, () => {
			this.userHasSelectedTab = true;
			if (newSimId != null) {
				this._followUpCreatedSimulationId = newSimId;
				this.setState(
					{
						activeTabFilter: newSimId,
						simulationId: newSimId,
						expiredProgress: 0,
						statusFilter: "all",
						selectedIps: [],
						filterDraftActivity: "all",
						filterDraftIps: [],
						fileTypeFilter: "all",
						filterDraftFileType: "all",
						userDetailsFilterPanelOpen: false,
						userDetailsFilterTab: "activity",
						search: "",
						activePage: 1,
					},
					() => {
						this.prepareRefresh();
						this.getDetails();
					}
				);
			} else {
				this._followUpCreatedSimulationId = null;
				this.prepareRefresh();
				this.getDetails();
			}
		});
	};

	loadSimulationDataAsync = () => {
		return Promise.all([
			this.load(),
			this.loadIps(),
			this.loadTotal(),
			this.loadBreachAndIncident(),
			...(this.state.key === "by-templates" ? [this.handleMyTemplates()] : []),
		]);
	};

	loadTotal = () => {
		// Same staleness guard as getDetails(): if the user switches tabs again before this
		// resolves, a slower earlier response landing later must not overwrite the newer tab's
		// status/attackType/credentialHarvesting with the previous tab's values.
		const totalSeq = ++this._totalSeq;
		return axios
			.get("/api/simulation/", {
				params: {
					campaignId: this.state.campaignId,
					simulationId: this.state.simulationId,
				},
			})
			.then((res) => {
				if (totalSeq !== this._totalSeq) return;
				this._deferChartMetaFromDetails = false;
				if (res.data.simulation) {
					var status = {};
					if (res.data.simulation.status) {
						for (var i = 0; i < res.data.simulation.status.length; i++) {
							var data = res.data.simulation.status[i];
							status[data["message"]] = parseInt(data["count"], 10) ? parseInt(data["count"], 10) : 0;
						}
					}
					const sim = res.data.simulation;
					const camp = sim.campaign || {};
					const attackType = camp.attack_type ? camp.attack_type.name : "";
					// Simulation type + credential harvesting are read from the simulation now.
					const simulationType = (sim.simulation_type?.name || "").trim();
					const chRaw = this.pickCredentialHarvestingRaw(sim);
					const chCoerced = this.coerceCredentialHarvesting(chRaw);
					const credentialHarvesting =
						chCoerced !== undefined ? chCoerced : this.state.credentialHarvesting;
					const iaFromSim = this.pickInstantAwarenessFromSimulation(res.data.simulation, camp);
					this._simulationMetricsLoaded = true;
					this.setState({
						status: status,
						loading: false,
						userCount: sim.userCount,
						isRepliedCampaign: res.data.simulation.isRepliedCampaign,
						disabledClosedBtn: res.data.simulation.completedAt && (new Date(res.data.simulation.completedAt) < new Date()) ? true : false,
						attackType,
						simulationType: simulationType || this.state.simulationType,
						credentialHarvesting,
						completesOn: res.data.simulation.completesOn,
						phishRate: res.data.simulation.phishRate,
						clickRate: res.data.simulation.clickRate,
						industryRisk: res.data.industryRisk || 4.3,
						evsScore: res.data.simulation.evsScore,
						healthScore: res.data.simulation.health,
						simulationIsScheduled: sim.isScheduled,
						followUpCondition: res.data.simulation.followupcondition,
						parentSimulationId: res.data.simulation.parentSimulationId,
						...(iaFromSim !== undefined ? { instantAwareness: iaFromSim } : {}),
					});
				}
			})
			.catch((error) => {
				if (totalSeq !== this._totalSeq) return;
				this._deferChartMetaFromDetails = false;
				apiError(error);
			});
	};

	handleSelect = (key) => {
		this.setState({ key }, this.reloadActiveUserAnalyticsTab);
	};

	reloadActiveUserAnalyticsTab = () => {
		if (this.state.key === "by-templates") {
			this.handleMyTemplates();
		} else {
			this.load();
		}
	};

	handleMyTemplates = () => {
		return axios.get(`/api/campaigns/${this.state.campaignId}/templates`, {
			params: {
				simulationId: this.state.simulationId,
				search: this.state.search ? this.state.search : null,
			},
		})
			.then((res) => {
				const data = res.data;
				this.setState({
					myTemplates: Array.isArray(data) ? data : (data.templates || data.results || []),
				});
			})
			.catch((err) => {
				apiError(err);
			});
	};

	load = () => {
		if (cancelRequest) cancelRequest();
		return axios.get("/api/results", {
			params: {
				limit: this.state.limit,
				search: this.state.search,
				page: this.state.activePage,
				filter: this.state.statusFilter,
				campaignId: this.state.campaignId,
				simulationId: this.state.simulationId,
				ips: this.state.selectedIps.map(ip => ip.value),
				...(this.isRansomwareAttack() &&
					this.state.fileTypeFilter &&
					this.state.fileTypeFilter !== "all"
					? { filetype: [this.state.fileTypeFilter] }
					: {}),
			},
			cancelToken: new CancelToken(function executor(c) {
				cancelRequest = c;
			}),
		})
			.then((res) => {
				this.setState({
					loading: false,
					count: res.data.count,
					results: res.data.results || [],
				});
			})
			.catch((error) => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ campaigns: [], count: 0, loading: false });
					apiError(error);
				}
			});
	};

	handleDeleteCampaign = (e, campaignId) => {
		e.stopPropagation();
		customSwal({
			title: "Move to Deleted Campaigns?",
			description: "The campaign will be moved to 'Deleted Campaigns'. After the 7 days, it will be permanently deleted and cannot be recovered. All associated analytics and any linked follow-up campagin will also be removed.",
			badgeText: "You can restore this campaign within 7 days before it is permanently removed.",
			icon: "danger",
			buttons: ["No", "Yes"],
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				axios.post('/api/campaigns/delete', { campaignIds: [campaignId] })
					.then((res) => {
						toast.success(res.data.message);
						const from = this.getFromSource();
						this.props.history.push(
							from === "test-campaign" ? "/campaign/test-campaign" : "/campaign/deleted-campaign"
						);
					})
					.catch((err) => apiError(err));
			}
		});
	};

	handleFilterEventCsv = () => {
		axios
			.get("/api/results/eventcsv", {
				params: {
					campaignId: this.state.campaignId,
					simulationId: this.state.simulationId,
					ips: this.state.selectedIps.map(ip => ip.value),
					filter: this.state.statusFilter && this.state.statusFilter !== "all" ? this.state.statusFilter : null,
					...(this.isRansomwareAttack() &&
						this.state.fileTypeFilter &&
						this.state.fileTypeFilter !== "all"
						? { filetype: [this.state.fileTypeFilter] }
						: {}),
					tzOffset: new Date().getTimezoneOffset() !== 0 ? new Date().getTimezoneOffset() : 0,
				},
				responseType: 'blob',
			})
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${this.state?.details?.campaign?.name}-event.csv`)
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err) => {
				apiError(err);
			});
	};

	handleFilterCsv = () => {
		axios
			.get("/api/results/csv", {
				params: {
					campaignId: this.state.campaignId,
					simulationId: this.state.simulationId,
					ips: this.state.selectedIps.map(ip => ip.value),
					filter: this.state.statusFilter && this.state.statusFilter !== "all" ? this.state.statusFilter : null,
					...(this.isRansomwareAttack() &&
						this.state.fileTypeFilter &&
						this.state.fileTypeFilter !== "all"
						? { filetype: [this.state.fileTypeFilter] }
						: {}),
				},
				responseType: 'blob', // Ensure the response type is set to blob for file download
			})
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${this.state?.details?.campaign?.name}.csv`)
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err) => {
				apiError(err);
			});
	};

	/* Simulation + Training export — one row per user with the simulation columns and
	   the LMS training columns side by side. Same filters as handleFilterCsv so the
	   file matches whatever the user is currently looking at. */
	handleFilterSimulationTrainingCsv = () => {
		axios
			.get("/api/results/simulationtraining/csv", {
				params: {
					campaignId: this.state.campaignId,
					simulationId: this.state.simulationId,
					ips: this.state.selectedIps.map(ip => ip.value),
					filter: this.state.statusFilter && this.state.statusFilter !== "all" ? this.state.statusFilter : null,
					...(this.isRansomwareAttack() &&
						this.state.fileTypeFilter &&
						this.state.fileTypeFilter !== "all"
						? { filetype: [this.state.fileTypeFilter] }
						: {}),
				},
				responseType: 'blob',
			})
			.then((res) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${this.state?.details?.campaign?.name}-simulation-training.csv`)
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err) => {
				apiError(err);
			});
	};


	loadBreachAndIncident = () => {
		return axios
			.get("/api/results/breach/incedent", {
				params: {
					campaignId: this.state.campaignId,
					simulationId: this.state.simulationId,
				},
			})
			.then((res) => {
				if (res.data.result_be) {
					this.setState({ breachTime: this.secondsToHms(res.data.result_be.breachTime) });
				}
				if (res.data.result_in) {
					this.setState({ incedent: this.secondsToHms(res.data.result_in.incidentTime) });
				}
			})
			.catch((err) => {
				apiError(err);
			});
	};

	/* The send-failure banner used to say "emails" for every campaign, so an SMS or
	   WhatsApp run reported errors about emails it never sent. Read the channel off
	   the status map the backend returned rather than re-deriving it from the attack
	   type: the delivery stage IS the channel, and it already accounts for the
	   vectors that are email-delivered despite their name (inbound Vishing and
	   inbound AI WhatsApp both arrive as email, so they carry "Email Sent"). */
	getDeliveryWording = () => {
		const status = this.state.status || {};
		if ("SMS Sent" in status) {
			return { what: "sending SMS", retry: "Retry SMS Sending", confirm: "Do you want to resend the SMS for pending users?" };
		}
		if ("Message Sent" in status) {
			return { what: "sending messages", retry: "Retry Message Sending", confirm: "Do you want to resend the message for pending users?" };
		}
		if ("Call Initiated" in status) {
			return { what: "placing calls", retry: "Retry Calls", confirm: "Do you want to retry the calls for pending users?" };
		}
		return { what: "sending emails", retry: "Retry Email Sending", confirm: "Do you want to resend the mail for pending users?" };
	};

	handleResend = () => {
		swal({
			title: this.getDeliveryWording().confirm,
			icon: "info",
			buttons: ["No", "Yes"],
			dangerMode: true,
		}).then((willSuccess) => {
			if (willSuccess) {
				this.setState({ loading: true });
				axios
					.post("/api/simulation/resend", {
						campaignId: this.state.campaignId,
						simulationId: this.state.simulationId,
					})
					.then((r) => {
						this.setState({ loading: false });
						toast.success("Resend in progress. Results will be updated soon.");
					})
					.catch((error) => {
						apiError(error);
						this.setState({ loading: false });
					});
			}
		});
	};

	closeCampaign = () => {
		swal({
			text: "Ending your campaign will disable the tracking of all the actions and users will no longer be able to access the landing or drop off page",
			title: "Do You Want To End Campaign?",
			icon: "info",
			buttons: ["No", "Yes"],
			dangerMode: true,
		}).then((willSuccess) => {
			if (willSuccess) {
				this.setState({ loading: true });
				axios
					.post("/api/simulation/complete", {
						campaignId: this.state.campaignId,
						simulationId: this.state.simulationId,
					})
					.then((r) => {
						toast.success("Campaign Close Successfully");
						this.setState({ loading: false, disabledClosedBtn: true }, () => {
							this.getDetails();
						});
					})
					.catch((error) => {
						apiError(error);
						this.setState({ loading: false });
					});
			}
		});
	};

	handleCreateGroup = (filter) => {
		this.setState({ loading: true });
		axios.patch("/api/targets/campaign", {
			filter,
			campaignId: this.state.campaignId,
			simulationId: this.state.simulationId,
		})
			.then((r) => {
				toast.success("Group Created Successfully");
				this.setState({ loading: false });
			})
			.catch((error) => {
				apiError(error);
				this.setState({ loading: false });
			});
	}

	handleActiveCampaign = (resultId) => {
		if (this.state.activeId === resultId) {
			this.setState({ activeId: "" });
		} else {
			this.setState({ activeId: resultId });
		}
	};

	getDateFromTwoDate = (first, second) => {
		return Math.ceil((new Date(second) - new Date(first)) / (1000 * 60 * 60 * 24));
	}

	handleIps = (selectedIps) => {
		this.setState({ selectedIps }, () => this.load())
	}

	getResultFileType = (result) => {
		const raw =
			result?.os_type ??
			result?.fileType ??
			result?.filetype ??
			result?.target?.os_type ??
			'';
		const normalized = String(raw).trim().toLowerCase();
		if (normalized.includes('mac') || normalized === 'darwin' || normalized === 'osx') {
			return FILE_TYPE_FILTER_MAC;
		}
		if (normalized.includes('win')) {
			return FILE_TYPE_FILTER_WINDOWS;
		}
		return null;
	};

	getResultFileTypeLabel = (result) => {
		const value = this.getResultFileType(result);
		return value ? this.getFileTypeFilterLabel(value) : "—";
	};


	getFileTypeFilterLabel = (value) => {
		const option = FILE_TYPE_FILTER_OPTIONS.find((item) => item.value === value);
		return option ? option.label : "—";
	};

	isRansomwareAttack = () => this.state.attackType === "Ransomware";

	applyUserDetailsFilters = () => {
		const draftFileType = this.isRansomwareAttack()
			? (this.state.filterDraftFileType || "all")
			: "all";
		this.setState(
			{
				statusFilter: this.state.filterDraftActivity || 'all',
				selectedIps: Array.isArray(this.state.filterDraftIps) ? this.state.filterDraftIps : [],
				fileTypeFilter: draftFileType,
				userDetailsFilterPanelOpen: false,
				userDetailsFilterTab: "activity",
				activePage: 1,
			},
			() => this.load()
		);
	};

	removeUserDetailsFilter = (type, value) => {
		if (type === 'activity') {
			this.setState({ statusFilter: 'all', activePage: 1 }, () => this.load());
		} else if (type === 'ip' && value != null) {
			this.setState(
				(prev) => ({
					selectedIps: prev.selectedIps.filter((ip) => (ip && ip.value) !== value),
					activePage: 1,
				}),
				() => this.load()
			);
		} else if (type === 'fileType') {
			this.setState(
				{ fileTypeFilter: 'all', filterDraftFileType: 'all', activePage: 1 },
				() => this.load()
			);
		}
	};

	nextPath = path => this.props.history.push(path);

	getFromSource = () => {
		const search = new URLSearchParams(this.props.location.search || '');
		const fromQuery = search.get('from');
		const fromState = this.props.location.state?.from;
		return fromQuery || fromState || 'campaign';
	};

	getBackLink = () => {
		const from = this.getFromSource();
		if (from === 'test-campaign') return '/campaign/test-campaign';
		if (from === 'deleted-campaign') return '/campaign/deleted-campaign';
		return '/campaign';
	};

	getPageTitle = () => {
		const from = this.getFromSource();
		if (from === 'deleted-campaign') return 'Deleted Campaign';
		const campaignName = this.state.details?.campaign?.name;
		const name = (campaignName && String(campaignName).trim()) ? campaignName : null;
		if (from === 'test-campaign') return name || 'Test Campaign';
		return name || 'Campaign';
	};

	canRenameCampaign = () => {
		if (this.getFromSource() === "deleted-campaign") return false;
		const id = this.state.campaignId;
		return Number.isFinite(id) && id > 0;
	};

	startEditCampaignName = () => {
		const raw = this.state.details?.campaign?.name;
		this.setState({
			editingCampaignName: true,
			campaignNameDraft: raw != null ? String(raw) : "",
			campaignNameInputError: "",
		});
	};

	cancelEditCampaignName = () => {
		this.setState({
			editingCampaignName: false,
			campaignNameDraft: "",
			campaignNameInputError: "",
			campaignNameSaveLoading: false,
		});
	};

	handleCampaignNameKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			this.saveCampaignName();
		} else if (e.key === "Escape") {
			e.preventDefault();
			this.cancelEditCampaignName();
		}
	};

	saveCampaignName = () => {
		const trimmed = (this.state.campaignNameDraft || "").trim();
		if (!trimmed) {
			this.setState({ campaignNameInputError: "Campaign name is required" });
			return;
		}
		const current = (this.state.details?.campaign?.name && String(this.state.details.campaign.name).trim()) || "";
		if (trimmed === current) {
			this.cancelEditCampaignName();
			return;
		}
		this.setState({ campaignNameSaveLoading: true, campaignNameInputError: "" });
		axios
			.patch(`/api/campaigns/${this.state.campaignId}`, { name: trimmed })
			.then(() => {
				toast.success("Campaign name updated");
				this.setState(
					{
						editingCampaignName: false,
						campaignNameSaveLoading: false,
						campaignNameDraft: "",
					},
					() => this.getDetails()
				);
			})
			.catch((error) => {
				apiError(error);
				this.setState({ campaignNameSaveLoading: false });
			});
	};

	/** Activity filter / dropdown options for current attack type (and Vishing inbound vs outbound). */
	getActivityFilterOptions = () => {
		const { attackType, targetInteractionType } = this.state;
		const vishingOutbound = ['Call Initiated', 'Call Picked', 'Data Submitted', 'Pending'];
		const vishingInbound = ['Email Sent', 'Email Opened', 'Call Received', 'Data Submitted', 'Replied', 'Email Reported', 'Pending'];

		const whatsappOutbound = ['Message Sent', 'Link Clicked', 'Data Submitted', 'Pending'];
		const whatsappInbound = ['Email Sent', 'Email Opened', 'Link Clicked', 'Data Submitted', 'Replied', 'Email Reported', 'Pending'];
		const byAttack = {
			Phishing: ['Email Sent', 'Email Opened', 'Link Clicked', 'Data Submitted', 'Replied', 'Email Reported', 'Pending'],
			Ransomware: ['Email Sent', 'Email Opened', 'Link Clicked', 'Email Reported', 'System Hacked', 'Replied', 'Email Reported', 'Pending'],
			Smishing: ['SMS Sent', 'Link Clicked', 'Data Submitted', 'Pending'],
			Vishing: vishingOutbound,
			WhatsApp: whatsappOutbound,
			Attachment: ['Email Sent', 'Email Opened', 'Attachment Opened', 'Replied', 'Email Reported', 'Pending'],
			QRcode: ['Email Sent', 'Email Opened', 'Link Clicked', 'Data Submitted', 'Replied', 'Email Reported', 'Pending'],
			Telegram: ['Message Sent', 'Link Clicked', 'Data Submitted', 'Pending'],
		};
		if (!attackType) return [];
		let list;
		if (attackType === 'Vishing' && targetInteractionType === 'inbound') {
			list = vishingInbound;
		} else if (attackType === 'WhatsApp' && targetInteractionType === 'inbound') {
			list = whatsappInbound;
		} else {
			list = byAttack[attackType];
		}
		if (!Array.isArray(list)) return [];
		return [...new Set(list)];
	};

	/** Open the training campaign in Krademy LMS (authenticated via the /api/lms proxy). */
	openTrainingSummary = async () => {
		if (!this.state.lmsUrl) return;
		let path = this.state.lmsUrl;
		try { path = new URL(this.state.lmsUrl).pathname; } catch (e) { /* lmsUrl may already be a path */ }
		try {
			document.body.style.cursor = "wait";
			const res = await axios.get("/api/lms", { params: { url: path } });
			document.body.style.cursor = "";
			if (res.data && res.data.url) {
				window.open(res.data.url, "_blank");
			} else {
				window.open(this.state.lmsUrl, "_blank");
			}
		} catch (err) {
			document.body.style.cursor = "";
			apiError(err);
		}
	};
	
	loadSelectedTrainingCourses = async () => {
		const selectedCourses = this.state.trainingSummary?.courses || [];
		const courseIds = selectedCourses.map((course) => course.courseId).filter(Boolean);

		if (!courseIds.length) {
			this.setState({ trainingSummaryLoading: false, trainingSummaryCourses: [] });
			return;
		}

		try {
			const response = await axios.get("/api/lms/course-detail", {
				params: { courseIds: courseIds.join(",") },
			});
			const courseDetails = Array.isArray(response.data?.courses) ? response.data.courses : [];
			const detailsById = {};
			courseDetails.forEach((course) => {
				detailsById[course.id ?? course.courseId] = course;
			});

			this.setState({
				trainingSummaryLoading: false,
				trainingSummaryCourses: selectedCourses.map((selectedCourse) => {
					const course = detailsById[selectedCourse.courseId] || {};
					return {
						courseId: selectedCourse.courseId,
						name: course.name || `Course ${selectedCourse.courseId}`,
						logo: course.logo || "",
						learners: 0,
						notStarted: 0,
						inProgress: 0,
						completed: 0,
						completionRate: 0,
						isPreLaunch: true,
					};
				}),
				trainingImageURL: response.data?.imageURL || "",
			});
		} catch (err) {
			this.setState({ trainingSummaryLoading: false, trainingSummaryCourses: [] });
			apiError(err);
		}
	};

	/** Load per-course training progress for the Training Summary tab. */
	loadTrainingSummary = async () => {
		const awarenessId = this.state.details?.awarenessId;
		if (!awarenessId) {
			await this.loadSelectedTrainingCourses();
			return;
		}
		this.setState({ trainingSummaryLoading: true });
		try {
			const res = await axios.get("/api/lms/training-summary", { params: { awarenessId } });
			const payload = res.data || {};
			/* Guarantee an array — the API may return courses as a plain array,
			   a paginated object ({rows}), or nested under data. Anything else
			   falls back to [] so the render never crashes on .map. */
			const rawCourses = payload.courses;
			let rows = [];
			if (Array.isArray(rawCourses)) rows = rawCourses;
			else if (Array.isArray(rawCourses?.data)) rows = rawCourses.data;
			else if (Array.isArray(rawCourses?.courses)) rows = rawCourses.courses;
			else if (Array.isArray(rawCourses?.rows)) rows = rawCourses.rows;
			else if (Array.isArray(payload?.data?.courses)) rows = payload.data.courses;
			else if (rawCourses != null) console.warn("training-summary: unexpected courses shape", payload);

			/* Normalize krademy's field names (pending/wip/done/total/percent)
			   to what the card render expects. */
			let courses = rows.map((c) => ({
				courseId: c.courseId,
				name: c.name || "",
				logo: c.logo || "",
				learners: Number(c.learners ?? c.total ?? 0),
				notStarted: Number(c.notStarted ?? c.pending ?? 0),
				inProgress: Number(c.inProgress ?? c.wip ?? 0),
				completed: Number(c.completed ?? c.done ?? 0),
				completionRate: Math.round(Number(c.completionRate ?? c.percent ?? 0)),
			}));
			this.setState({
				trainingSummaryLoading: false,
				trainingSummaryCourses: courses,
				trainingImageURL: payload.imageURL || "",
				trainingPreviewURL: payload.previewURL || "",
			});

			/* training-summary has no course name/logo — enrich from the existing
			   /api/lms/course-detail endpoint by courseId. */
			const ids = courses.map((c) => c.courseId).filter(Boolean);
			if (ids.length) {
				try {
					const dRes = await axios.get("/api/lms/course-detail", { params: { courseIds: ids.join(",") } });
					const details = Array.isArray(dRes.data?.courses) ? dRes.data.courses : [];
					const byId = {};
					details.forEach((d) => { byId[d.id ?? d.courseId] = d; });
					const enriched = courses.map((c) => ({
						...c,
						name: c.name || byId[c.courseId]?.name || `Course ${c.courseId}`,
						logo: c.logo || byId[c.courseId]?.logo || "",
					}));
					this.setState({
						trainingSummaryCourses: enriched,
						trainingImageURL: this.state.trainingImageURL || dRes.data?.imageURL || "",
					});
				} catch (e) { /* keep counts even if name/logo enrichment fails */ }
			}
		} catch (err) {
			const errorData = err.response?.data || {};
			const errorMessage = String(errorData.message || errorData.error || errorData?.data?.message || "");
			const campaignNotCreated = err.response?.status === 404 || /no campaign found/i.test(errorMessage);

			if (campaignNotCreated) {
				await this.loadSelectedTrainingCourses();
				return;
			}

			this.setState({ trainingSummaryLoading: false });
			apiError(err);
		}
	};

	render() {
		let names = "";
		const groupName = this.state.groupName;
		if (groupName && groupName.length > 0) {
			names = groupName
				.filter(element => element.group.type !== "simulation-generated")
				.map(element => element.group.name)
				.join(", ");
		}
		const activityFilterOptions = this.getActivityFilterOptions();
		const isRansomwareAttack = this.isRansomwareAttack();
		const userAnalyticsTableColSpan = isRansomwareAttack ? 8 : 7;
		const simulationsForHeaderStatus = this.state.details?.campaign?.simulations ?? [];
		const campaignStatusLabel =
			aggregateCampaignStatusFromSimulations(simulationsForHeaderStatus) ??
			this.state.details?.campaignStatus ??
			this.props.location?.state?.campaignStatusParent ??
			"In Progress";
		const TotalCount = this.state.status['Total'] ? this.state.status['Total'] : 1;
		// QR campaigns always use scan/link metrics, not phish-risk labeling (even with credential harvesting on).
		const usePhishRiskMetrics =
			this.state.attackType !== "QRcode" &&
			(this.state.credentialHarvesting ||
				(this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") ||
				this.state.attackType === "Attachment");
		const riskType = this.state.attackType === "QRcode" ? "QR Scan" : usePhishRiskMetrics ? "Phish Risk" : "Link Click";
		const risk = usePhishRiskMetrics ? this.state.phishRate : this.state.clickRate;
		const mediumRiskThreshold = usePhishRiskMetrics ? this.state.industryRisk : 30;
		const lowRiskThreshold = usePhishRiskMetrics ? this.state.industryRisk : 30;
		const headerHealthPct = this.state.campaignHealthForHeader;
		const healthMeterScore = headerHealthPct !== null ? headerHealthPct : 0;
		const filledDots = Math.min(10, Math.round((healthMeterScore / 100) * 10));
		const headerHealthFilledDotColor =
			healthMeterScore >= 80 ? HEALTH_DOT_GREEN_DARK : HEALTH_DOT_RED_DARK;
		const isPrimaryCampaign = (() => {
			const simulations = this.state.details?.campaign?.simulations ?? [];
			if (!simulations.length) return false;
			return parseInt(simulations[0]?.id, 10) === this.state.activeTabFilter;
		})();
		const isFromTestCampaign = this.getFromSource() === 'test-campaign';
		return (
			<div className="content-wrap grey-bg">
				<div className="campaign-edit-header-container">
					<div className="campaign-edit-header">
						<div className="campaign-edit-header-left">
							<h4 className="page-title campaign-page-title-row">
								<a onClick={e => this.props.history.push(this.getBackLink())} className="bar_Icons campaign-header-back-btn">
									<ArrowBackSharpIcon className="btn-icon" />
								</a>
								{!this.state.editingCampaignName ? (
									<>
										<span className="campaign-page-title-text" title={this.getPageTitle()}>
											{this.getPageTitle()}
										</span>
										{this.canRenameCampaign() && (
											<OverlayTrigger
												placement="bottom"
												overlay={<Tooltip id="campaign-rename-tip">Rename campaign</Tooltip>}
											>
												<button
													type="button"
													className="campaign-name-edit-btn"
													onClick={this.startEditCampaignName}
													aria-label="Rename campaign"
												>
													<PiPencilSimple size={13} aria-hidden />
												</button>
											</OverlayTrigger>
										)}
										<Badge
											className={`campaign-status-badge-header ${{
												completed: "badge-soft-success",
												"in progress": "badge-soft-primary",
												scheduled: "badge-soft-secondary"
											}[campaignStatusLabel.toLowerCase()] || "badge-soft-light"
												}`}
										>
											{campaignStatusLabel}
										</Badge>
									</>
								) : (
									<div className="campaign-name-inline-editor">
										<div className="campaign-name-inline-editor-panel">
											<div className="campaign-name-inline-editor-inner">
												<FormControl
													type="text"
													className="campaign-name-inline-input"
													value={this.state.campaignNameDraft}
													onChange={(e) =>
														this.setState({
															campaignNameDraft: e.target.value,
															campaignNameInputError: "",
														})
													}
													onKeyDown={this.handleCampaignNameKeyDown}
													isInvalid={!!this.state.campaignNameInputError}
													disabled={this.state.campaignNameSaveLoading}
													maxLength={200}
													autoFocus
													placeholder="Campaign name"
													aria-label="Campaign name"
												/>
												<div className="campaign-name-inline-actions">
													<Button
														type="button"
														variant="primary"
														className="campaign-name-action-btn btn-trans-success campaign-name-icon-btn "
														onClick={this.saveCampaignName}
														disabled={this.state.campaignNameSaveLoading}
														title="Save"
														aria-label="Save"
													>
														{this.state.campaignNameSaveLoading ? (
															<span className="campaign-name-save-spinner">…</span>
														) : (
															<PiCheck size={16} aria-hidden />
														)}
													</Button>
													<Button
														type="button"
														variant="outline-secondary"
														className="campaign-name-action-btn btn-trans-danger campaign-name-icon-btn"
														onClick={this.cancelEditCampaignName}
														disabled={this.state.campaignNameSaveLoading}
														title="Cancel (Esc)"
														aria-label="Cancel"
													>
														<PiX size={16} aria-hidden />
													</Button>

												</div>
											</div>
											{this.state.campaignNameInputError ? (
												<div className="campaign-name-inline-error" role="alert">
													{this.state.campaignNameInputError}
												</div>
											) : null}
										</div>
										<Badge
											className={`campaign-status-badge-header campaign-status-badge-header--editor ${{
												completed: "badge-soft-success",
												"in progress": "badge-soft-primary",
												scheduled: "badge-soft-secondary"
											}[campaignStatusLabel.toLowerCase()] || "badge-soft-light"
												}`}
										>
											{campaignStatusLabel}
										</Badge>
									</div>
								)}
							</h4>
						</div>
						<div className="campaign-edit-header-right">
							<div>
								<div
									className="evs-table-card__risk campaign-list-health-meter pr-0"
									style={{ minWidth: "0", justifyContent: "flex-end", width: "unset" }}
								>
									<PiShield className="evs-table-card__risk-icon" />
									<div className="evs-table-card__risk-dots">
										{Array.from({ length: 10 }, (_, i) => (
											<span
												key={i}
												className={`evs-table-card__risk-dot ${i < filledDots ? "evs-table-card__risk-dot--filled" : ""}`}
												style={
													i < filledDots
														? {
															"--campaign-health-dot": headerHealthFilledDotColor,
															backgroundColor: headerHealthFilledDotColor,
														}
														: undefined
												}
											/>
										))}
									</div>
									<span
										className="evs-table-card__risk-pct campaign-list-health-meter__pct"
										style={
											headerHealthPct !== null
												? {
													"--campaign-health-pct":
														healthMeterScore >= 80 ? HEALTH_DOT_GREEN_DARK : HEALTH_DOT_RED_DARK,
												}
												: undefined
										}
									>
										{headerHealthPct !== null ? `${headerHealthPct}%` : "-"}
									</span>
								</div>
								<span className="health-cm">Overall Campaign Health</span>
							</div>
						</div>
					</div>
					<div className="campaign-details-container">
						<div className="left-details-container">
							<div className="detail-item">
								<p>Attack Vector</p>
								<h5>{this.state.attackType}</h5>
							</div>
							{(this.state.attackType === "WhatsApp" || this.state.attackType === "Vishing") && (
								<div className="detail-item">
									<p>Mode</p>
									<h5>
										{this.state.targetInteractionType === "inbound" && this.state.isAIbased
											? this.state.attackType === "WhatsApp" ? "AI Conversational (Chat Bot)" : "AI Conversational (Voice Bot)"
											: this.state.attackType === "WhatsApp" ? "Direct WhatsApp Message" : "IVR (Keypad-based)"}
									</h5>
								</div>
							)}
							<div className="detail-item">
								<p>Type</p>
								<h5>{this.state.simulationType}</h5>
							</div>

							<div className="detail-item">
								<p>Created On</p>
								<h5>{getDateWithoutTime(this.state.createdAt)}</h5>
							</div>
							{
								!isFromTestCampaign && (
									<div className="detail-item">
										<p>Follow-up Campaigns</p>
										<h5>{this.state.followUpCampaign > 0 ? (this.state.followUpCampaign - 1) : 0}</h5>
									</div>
								)
							}
							<div className="detail-item">
								<p>Users</p>
								<h5>{this.state.userCount}</h5>
							</div>
							<div className="detail-item">
								<p>Groups</p>
								<h5>{this.state.groupCount}</h5>
							</div>
						</div>
						<div className="right-details-container">
							{isPrimaryCampaign && (
								<button
									type="button"
									className="campaign-detail-delete-btn"
									aria-label="Delete"
									onClick={(e) => this.handleDeleteCampaign(e, this.state.campaignId)}
								>
									<PiTrash />
								</button>
							)}
						</div>
					</div>
				</div>

				<div className="campaign-edit-tab-filter common-card p-2">
					<ul className="campaign-edit-tab-filter-list">
						{
							this.state.details?.campaign?.simulations.map((simulation) => {
								const simIdNum = simulation?.id != null ? parseInt(simulation.id, 10) : null;
								const isActive =
									simIdNum != null &&
									!Number.isNaN(simIdNum) &&
									Number(this.state.activeTabFilter) === simIdNum;
								return (
									<li
										key={simulation?.id ?? simIdNum}
										className={`campaign-edit-tab-filter-list-item ${isActive ? "active" : ""}`}
										onClick={() => {
											if (simIdNum != null && !Number.isNaN(simIdNum)) {
												const switchingSimTab =
													Number(this.state.activeTabFilter) !== simIdNum;
												this.userHasSelectedTab = true;
												this.setState(
													{
														activeTabFilter: simIdNum,
														simulationId: simIdNum,
														expiredProgress: 0,
														...(switchingSimTab
															? {
																statusFilter: "all",
																selectedIps: [],
																filterDraftActivity: "all",
																filterDraftIps: [],
																fileTypeFilter: "all",
																filterDraftFileType: "all",
																userDetailsFilterPanelOpen: false,
																userDetailsFilterTab: "activity",
																search: "",
																activePage: 1,
															}
															: {}),
													},
													() => {
														this.prepareRefresh();
														this.getDetails();
													}
												);
											}
										}}
									>
										{simulation.name}
										<Badge
											variant="secondary"
											className="simulation-status-badge"
											style={{
												color: simulation?.simulationStatus === "Completed" ? "#277150" :
													simulation?.simulationStatus === "In Progress" ? "#1867d2" : "#4a5057"
											}}
										>
											<PiCircleFill style={{ marginTop: "-2px" }} /> {simulation?.simulationStatus}
										</Badge>
									</li>
								);
							})
						}
					</ul>

					{!isFromTestCampaign && (
						this.state.primaryCampaignFollowUpEnabled ? (
							<OverlayTrigger placement="top" overlay={<Tooltip id="follow-up-campaign"> Create a follow-up campaign to target users based on specific actions from a previous campaign</Tooltip>}>
								<span className="d-inline-block" style={{ cursor: "pointer" }}>
									<Button variant="primary" className="btn-sm btn-with-icon" style={{ height: "32px" }} onClick={() => this.setState({ showFollowUpModal: true })}><TfiPlus /> Follow-up Campaign</Button>
								</span>
							</OverlayTrigger>
						) : (
							<OverlayTrigger placement="top" overlay={<Tooltip id="follow-up-disabled">At least one campaign must be completed before you can run a Follow-Up Campaign.</Tooltip>}>
								<span className="d-inline-block" style={{ cursor: "not-allowed" }}>
									<Button variant="primary" className="btn-sm btn-with-icon" disabled style={{ pointerEvents: "none", height: "32px" }}><TfiPlus /> Follow-up Campaign</Button>
								</span>
							</OverlayTrigger>
						)
					)}
				</div>


				<div className="campaign-edit-tab-filter-content common-card">
					<div className="campaign-edit-tabs-header">
						<Nav variant="tabs" activeKey={this.state.activeAnalyticsTab} onSelect={(k) => this.setState({ activeAnalyticsTab: k })} id="campaign-edit-analytics-tabs" className="campaign-edit-analytics-tabs">
							<Nav.Item>
								<Nav.Link eventKey="campaign-analytics"><PiChartLine className="tab-icon mr-2" />Campaign Analytics</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="user-analytics"><PiUsers className="tab-icon mr-2" />Users Analytics</Nav.Link>
							</Nav.Item>
							{this.state.trainingSummary?.enabled && (
								<Nav.Item>
									<Nav.Link eventKey="training-summary" onClick={() => this.loadTrainingSummary()}><PiBookOpen className="tab-icon mr-2" />Training Summary</Nav.Link>
								</Nav.Item>
							)}
							<Nav.Item>
								<Nav.Link eventKey="campaign-details"><PiListBullets className="tab-icon mr-2" />Campaign Details</Nav.Link>
							</Nav.Item>
							
						</Nav>
						<div className="campaign-edit-tabs-actions">
							<Button
								variant="secondary"
								className="mr-2 dropdown-btn-toggle"
								disabled={this.state.headerRefreshLoading || !(this.state.simulationId && this.state.campaignId)}
								onClick={(e) => this.handleRefresh()}
								aria-busy={this.state.headerRefreshLoading}
							>
								<PiArrowClockwiseLight className="dot-icon" />
							</Button>
							{this.state.simulationType === "Simulation Attack + Training" ? (
								<div className="d-inline-block position-relative mr-2 campaign-report-dropdown-wrapper">
									<span className=" campaign-report-dropdown-badge">*New</span>
									<Dropdown className="d-inline-block">
										<Dropdown.Toggle
											variant="secondary"
											id="campaign-report-dropdown"
											className="dropdown-btn-toggle btn-with-icon"
											disabled={!(this.state.simulationId && this.state.campaignId)}
										>
											<PiFileText className="dot-icon" /> Campaign Report
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item onClick={e => this.props.history.push(`/campaign/reports/${this.state.campaignId}/${this.state.simulationId}`)}>
												Simulation
											</Dropdown.Item>
											<Dropdown.Item onClick={e => this.props.history.push(`/campaign/simulation-training-report/${this.state.campaignId}/${this.state.simulationId}`)}>
												Simulation + Training
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							) : (
								<Button variant="secondary" className="mr-2 dropdown-btn-toggle btn-with-icon" onClick={e => this.props.history.push(`/campaign/reports/${this.state.campaignId}/${this.state.simulationId}`)} ><PiFileText className="dot-icon" /> Report</Button>
							)}

							<Dropdown className="d-inline-block">
								<Dropdown.Toggle id="export-dropdown-user-analytics" className="dropdown-color-white mr-2">
									Export
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={this.handleFilterCsv}>Simulation (.csv)</Dropdown.Item>
									{this.state.simulationType !== "Simulation Attack" && (
										<Dropdown.Item onClick={this.handleFilterSimulationTrainingCsv}>
											Simulation + Training (.csv)
										</Dropdown.Item>
									)}
									<Dropdown.Item onClick={this.handleFilterEventCsv}>Event Logs (.csv)</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
							<Dropdown
								className="action-dropdown dropdownIconBtn"
								show={this.state.actionDropdownOpen}
								onToggle={(isOpen) =>
									this.setState({
										actionDropdownOpen: isOpen,
										createGroupSubmenuOpen: false,
									})
								}
							>
								<Dropdown.Toggle
									className="dropdown-btn-toggle"
									id="dropdown-basic"
								>
									<MoreVertSharpIcon className="dot-icon" />
								</Dropdown.Toggle>

								<Dropdown.Menu>

									{/* End Campaign */}
									<Dropdown.Item
										onClick={this.closeCampaign}
										disabled={this.state.disabledClosedBtn}
									>
										End campaign
									</Dropdown.Item>

									{/* Nested Create Group Dropdown */}
									<Dropdown
										drop="end"
										show={this.state.createGroupSubmenuOpen}
										onToggle={(isOpen, e) => {
											if (e) e.stopPropagation();
											this.setState({ createGroupSubmenuOpen: isOpen });
										}}
									>
										<Dropdown.Toggle
											as="div"
											className="dropdown-item d-flex justify-content-between align-items-center"
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												this.setState((prevState) => ({
													createGroupSubmenuOpen: !prevState.createGroupSubmenuOpen,
												}));
											}}
										>
											Create group ▸
										</Dropdown.Toggle>

										<Dropdown.Menu>

											{'Call Picked' in this.state.status ? (
												<Dropdown.Item
													onClick={() => {
														this.setState({ actionDropdownOpen: false });
														this.handleCreateGroup('Call Picked');
													}}
												>
													Call Picked
												</Dropdown.Item>
											) : null}

											{'Link Clicked' in this.state.status ? (
												<Dropdown.Item
													onClick={() => {
														this.setState({ actionDropdownOpen: false });
														this.handleCreateGroup('Link Clicked');
													}}
												>
													Link Clicked
												</Dropdown.Item>
											) : null}

											{'Attachment Opened' in this.state.status ? (
												<Dropdown.Item
													onClick={() => {
														this.setState({ actionDropdownOpen: false });
														this.handleCreateGroup('Attachment Opened');
													}}
												>
													Attachment Opened
												</Dropdown.Item>
											) : null}

											{'Data Submitted' in this.state.status ? (
												<Dropdown.Item
													onClick={() => {
														this.setState({ actionDropdownOpen: false });
														this.handleCreateGroup('Data Submitted');
													}}
												>
													Data Submitted
												</Dropdown.Item>
											) : null}

											{'System Hacks' in this.state.status ? (
												<Dropdown.Item
													onClick={() => {
														this.setState({ actionDropdownOpen: false });
														this.handleCreateGroup('System Hacks');
													}}
												>
													System Hacks
												</Dropdown.Item>
											) : null}

										</Dropdown.Menu>
									</Dropdown>

								</Dropdown.Menu>
							</Dropdown>


						</div>
					</div>
					<div className="campaign-edit-tabs-content">

						{this.state.activeAnalyticsTab === 'campaign-analytics' && (
							<>
								{
									(this.state.status["Error"] > 0) ? (
										<Alert key={"danger"} variant={"danger"} className="alert-sm">
											<b>{this.state.status["Error"]} errors</b> occurred while {this.getDeliveryWording().what}. Click{" "}
											<span
												role="button"
												tabIndex={0}
												className="retry-email-sending-link"
												onClick={this.handleResend}
												onKeyDown={(e) => e.key === "Enter" && this.handleResend()}
											>
												{this.getDeliveryWording().retry}
											</span>{" "}
											to resolve them.
										</Alert>
									) : null
								}
								{this.state.attackType === "Vishing" && this.state.targetInteractionType === "inbound" &&
									<AiVishingMinuteConsumption />
								}
								<div className="campaign-analytics-content mb-3">
									<div className="campaign-analytics-donut-row">
										{'Total' in this.state.status && this.state.attackType === "Removal Media" ?
											<div className="campaign-analytics-donut-item">
												<Total
													value={this.state.status['Total']}
													percent={100}
												></Total>
											</div> : ''
										}{'Email Sent' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<EmailSend
													value={this.state.status['Email Sent']}
													// value={this.state.status['Email Sent']}
													percent={((this.state.status['Email Sent'] * 100) / TotalCount).toFixed(2)}
												></EmailSend>
												<span className="data-label-chart">Email Sent</span>
											</div> : ''
										}{'SMS Sent' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<SMSSend
													// value={this.state.status['SMS Sent']}
													value={this.state.status['SMS Sent']}
													percent={((this.state.status['SMS Sent'] * 100) / TotalCount).toFixed(2)}
												></SMSSend>
												<span className="data-label-chart">SMS Sent</span>
											</div> : ''
										}{'Message Sent' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<MessageSent
													value={this.state.status['Message Sent']}
													// value={this.state.status['Message Sent']}
													percent={((this.state.status['Message Sent'] * 100) / TotalCount).toFixed(2)}
												></MessageSent>
												<span className="data-label-chart">Message Sent</span>
											</div> : ''
										}{'Call Initiated' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<CallInitiated
													value={this.state.status['Call Initiated']}
													// value={this.state.status['Call Initiated']}
													percent={((this.state.status['Call Initiated'] * 100) / TotalCount).toFixed(2)}
												></CallInitiated>
												<span className="data-label-chart">Call Initiated</span>
											</div> : ''
										}{'Call Picked' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<CallPicked
													value={this.state.status['Call Picked']}
													percent={((this.state.status['Call Picked'] * 100) / TotalCount).toFixed(2)}
												></CallPicked>
												<span className="data-label-chart">Call Picked</span>
											</div> : ''
										}{'Email Opened' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<EmailOpened
													value={this.state.status['Email Opened']}
													percent={((this.state.status['Email Opened'] * 100) / TotalCount).toFixed(2)}
												></EmailOpened>
												<span className="data-label-chart">Email Opened</span>
												<OverlayTrigger
													placement="top"
													overlay={
														<Tooltip id="top">
															Email open tracking may not be 100% accurate as many ESPs block tracking images for security reasons.
														</Tooltip>
													}
												>
													<div className="disMsg">
														<IoInformation className="tooltip-icon"></IoInformation> <span>Disclaimer</span>
													</div>
												</OverlayTrigger>

											</div> : ''
										}{'Call Received' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<CallReceived
													value={this.state.status['Call Received']}
													percent={((this.state.status['Call Received'] * 100) / TotalCount).toFixed(2)}
												></CallReceived>
												<span className="data-label-chart">Call Received</span>
											</div> : ''
										}{'Link Clicked' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<LinkClicked
													value={this.state.status['Link Clicked']}
													percent={((this.state.status['Link Clicked'] * 100) / TotalCount).toFixed(2)}
													label={this.state.attackType === "QRcode" ? "QR Scanned" : "Link Clicked"}
												></LinkClicked>
												<span className="data-label-chart">{this.state.attackType === "QRcode" ? "QR Scanned" : "Link Clicked"}</span>
											</div> : ''
										}{'Attachment Opened' in this.state.status && (this.state.attackType === "Phishing" || this.state.attackType === "Ransomware" || this.state.attackType === "Attachment") ?
											<div className="campaign-analytics-donut-item">
												<AttachmentOpened
													value={this.state.status['Attachment Opened']}
													percent={((this.state.status['Attachment Opened'] * 100) / TotalCount).toFixed(2)}
												></AttachmentOpened>
												<span className="data-label-chart">Attachment Opened</span>
											</div> : ''
										}
										{'Data Submitted' in this.state.status && (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || ["Attachment", "Ransomware"].includes(this.state.attackType)) ?
											<div className="campaign-analytics-donut-item">
												<DataSubmitted
													value={this.state.status['Data Submitted']}
													percent={((this.state.status['Data Submitted'] * 100) / TotalCount).toFixed(2)}
												></DataSubmitted>
												<span className="data-label-chart">Data Submitted</span>
											</div> : ''
										}{'System Hacks' in this.state.status ?
											<div className="campaign-analytics-donut-item">
												<SystemHack
													value={this.state.status['System Hacks']}
													percent={((this.state.status['System Hacks'] * 100) / TotalCount).toFixed(2)}
												></SystemHack>
												<span className="data-label-chart">System Hacks</span>
											</div> : ''
										}{'Replied' in this.state.status && this.state.isRepliedCampaign ?
											<div className="campaign-analytics-donut-item">
												<Replied
													value={this.state.status['Replied']}
													percent={((this.state.status['Replied'] * 100) / TotalCount).toFixed(2)}
												></Replied>
												<span className="data-label-chart">Replied</span>
											</div> : ''
										}{'Email Reported' in this.state.status &&
											// Number(this.state.status['Email Reported']) > 0 &&
											(this.state.attackType === "Phishing" || this.state.attackType === "Ransomware" || this.state.attackType === "QRcode" || this.state.attackType === "Attachment") ?
											<div className="campaign-analytics-donut-item">
												<EmailReported
													value={this.state.status['Email Reported']}
													percent={((this.state.status['Email Reported'] * 100) / TotalCount).toFixed(2)}
												></EmailReported>
												<span className="data-label-chart">Email Reported</span>
												<OverlayTrigger
													placement="top"
													overlay={
														<Tooltip id="top">
															Reported metrics are available only for customers using TPIR and are recorded when users report phishing emails through the TPIR add-in.
														</Tooltip>
													}
												>
													<div className="disMsg">
														<IoInformation className="tooltip-icon"></IoInformation> <span>Disclaimer</span>
													</div>
												</OverlayTrigger>
											</div> : ''
										}
									</div>
								</div>
								<div className="campaign-analytics-cards">
									<Card className="campaign-analytics-demo-card">
										<Card.Body>
											<PiWarning className="campaign-analytics-demo-card-icon" />
											<h6 className="campaign-analytics-demo-card-heading">
												{riskType} Rate
												<OverlayTrigger placement="top" overlay={
													<Tooltip id="phishing-tip">
														{riskType === "Phish Risk"
															? `Percentage of users who submitted data out of those who received the ${((activityFilterOptions[0] || "")).split(" ")[0].toLowerCase()}.`
															: riskType === "QR Scan"
																? `Percentage of users who scanned the QR code out of those who received the ${((activityFilterOptions[0] || "")).split(" ")[0].toLowerCase()}.`
																: `Percentage of users who clicked on a link out of those who received the ${((activityFilterOptions[0] || "")).split(" ")[0].toLowerCase()}.`}
													</Tooltip>
												}>
													<span className="campaign-analytics-tooltip-wrap"><IoInformation className="tooltip-icon" /></span>
												</OverlayTrigger>
											</h6>
											<div className="campaign-analytics-demo-card-bottom">
												<p className="campaign-analytics-demo-card-percent">{(Number(risk) || 0)}%</p>
												<Badge variant={risk >= mediumRiskThreshold ? "danger" : risk < lowRiskThreshold ? "success" : "warning"} className={`campaign-analytics-demo-badge ${risk >= mediumRiskThreshold ? "badge-soft-danger" : risk < lowRiskThreshold ? "badge-soft-success" : "badge-soft-warning"}`}>
													{risk >= mediumRiskThreshold ? "High Risk" : risk < lowRiskThreshold ? "Low Risk" : "Moderate Risk"}
												</Badge>
											</div>
										</Card.Body>
									</Card>
									<Card className="campaign-analytics-demo-card">
										<Card.Body>
											<PiChartLine className="campaign-analytics-demo-card-icon" />
											<h6 className="campaign-analytics-demo-card-heading">
												Average EVS
												<OverlayTrigger placement="top" overlay={<Tooltip id="email-tip">Average Employee Vulnerability Score across the campaign.</Tooltip>}>
													<span className="campaign-analytics-tooltip-wrap"><IoInformation className="tooltip-icon" /></span>
												</OverlayTrigger>
											</h6>
											<div className="campaign-analytics-demo-card-bottom">
												<p className="campaign-analytics-demo-card-percent">{(Number(this.state.evsScore) || 0)}%</p>
												{/* <Badge variant="secondary" className="badge-soft-secondary campaign-analytics-demo-badge">—</Badge> */}
											</div>
										</Card.Body>
									</Card>
									{this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || ["Attachment", "Ransomware"].includes(this.state.attackType) ? (
										<Card className="campaign-analytics-demo-card">
											<Card.Body>
												<PiTimerLight className="campaign-analytics-demo-card-icon" />
												<h6 className="campaign-analytics-demo-card-heading">
													Minimum Breach Time
													<OverlayTrigger placement="top" overlay={<Tooltip id="security-tip">
														Minimum time taken by the first employee to submit their data in the simulated phishing campaign </Tooltip>}>
														<span className="campaign-analytics-tooltip-wrap"><IoInformation className="tooltip-icon" /></span>
													</OverlayTrigger>
												</h6>
												<div className="campaign-analytics-demo-card-bottom">
													<p className="campaign-analytics-demo-card-percent">{this.state.breachTime || "—"}</p>
													{/* <Badge variant="secondary" className="badge-soft-secondary campaign-analytics-demo-badge">{this.state.breachTime || "—"}</Badge> */}
												</div>
											</Card.Body>
										</Card>
									) : null}
									<Card className="campaign-analytics-demo-card">
										<Card.Body>
											<PiHeart className="campaign-analytics-demo-card-icon" />
											<h6 className="campaign-analytics-demo-card-heading">
												Remaining Health
												<OverlayTrigger placement="top" overlay={<Tooltip id="link-tip">Percentage of users who were not compromised (No Link clicked or Data submitted).</Tooltip>}>
													<span className="campaign-analytics-tooltip-wrap"><IoInformation className="tooltip-icon" /></span>
												</OverlayTrigger>
											</h6>
											<div className="campaign-analytics-demo-card-bottom">
												<p className="campaign-analytics-demo-card-percent">{Number(this.state.healthScore ?? 0)}%</p>
												<Badge
													variant={
														Number(this.state.healthScore ?? 0) < 80
															? "danger"
															: "success"
													}
													className={`campaign-analytics-demo-badge ${Number(this.state.healthScore ?? 0) < 80
														? "badge-soft-danger"
														: "badge-soft-success"
														}`}
												>
													{Number(this.state.healthScore ?? 0) < 80
														? "Critical"
														: "Healthy"}
												</Badge>
												{/* <Badge variant={(100 - this.state.healthScore) >= mediumRiskThreshold ? "danger" : (100 - this.state.healthScore) < lowRiskThreshold ? "success" : "warning"} className={`campaign-analytics-demo-badge ${(100 - this.state.healthScore) >= mediumRiskThreshold ? "badge-soft-danger" : (100 - this.state.healthScore) < lowRiskThreshold ? "badge-soft-success" : "badge-soft-warning"}`}>
													{(100 - this.state.healthScore) >= mediumRiskThreshold ? "Critical" : (100 - this.state.healthScore) < lowRiskThreshold ? "Healthy" : "Moderate"}
												</Badge> */}
											</div>
										</Card.Body>
									</Card>
								</div>
							</>
						)}
						{this.state.activeAnalyticsTab === 'user-analytics' && (
							<>
								<div className="filter-without-border new-filter-wrapper">
									<div className="align-items-center row">
										<div className="col-md-7">
											<div className="flex-filter">
												<div className="tab-wrapper me-3">
													<Tabs
														id="controlled-tab-example"
														activeKey={this.state.key}
														onSelect={this.handleSelect}
													>
														<Tab eventKey="all" title="All" />
														<Tab eventKey="by-templates" title="By Templates" />
													</Tabs>
													<span className="campaign-report-dropdown-badge">*New</span>

												</div>
												<div className="positionSearchIcon">
													<InputGroup className="search-wrap">
														<FormControl
															type="text"
															placeholder="Search"
															value={this.state.search}
															onChange={e => this.setState({ search: e.target.value }, () => this.reloadActiveUserAnalyticsTab())}
															className="inputSearch mr-sm-2 form-control"
														/>
														<SearchSharpIcon className="search-icon" />
													</InputGroup>
												</div>

											</div>

										</div>

										<div className="col-md-5">
											{this.state.key !== "by-templates" && (
											<div className="rightFilters">

												<Dropdown className="d-inline-block">
													<Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
														{this.state.limit}
													</Dropdown.Toggle>
													<Dropdown.Menu>
														{[10, 25, 50, 100].map((limit) => (
															<Dropdown.Item
																key={`limit-${limit}`}
																onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
																active={this.state.limit === limit}
															>
																{limit}
															</Dropdown.Item>
														))}
													</Dropdown.Menu>
												</Dropdown>

												<Dropdown
													show={this.state.userDetailsFilterPanelOpen}
													onToggle={(isOpen) => {
														if (isOpen) {
															const opts = this.getActivityFilterOptions();
															let draft = this.state.statusFilter || 'all';
															if (draft !== 'all' && opts.length && !opts.includes(draft)) draft = 'all';
															let filterTab = this.state.userDetailsFilterTab;
															if (
																!isRansomwareAttack &&
																filterTab === "file_type"
															) {
																filterTab = "activity";
															}
															this.setState({
																userDetailsFilterPanelOpen: true,
																userDetailsFilterTab: filterTab,
																filterDraftActivity: draft,
																filterDraftIps: Array.isArray(this.state.selectedIps)
																	? this.state.selectedIps
																	: [],
																filterDraftFileType: isRansomwareAttack
																	? (this.state.fileTypeFilter || "all")
																	: "all",
															});
														} else {
															this.setState({
																userDetailsFilterPanelOpen: false,
																userDetailsFilterTab: "activity",
															});
														}
													}}
													autoClose="outside"
												>
													<Dropdown.Toggle variant="secondary" id="filter-dropdown" className="dropdown-color-white mr-2">
														Filter
													</Dropdown.Toggle>
													<Dropdown.Menu className="filter-panel-dropdown p-0" style={{ minWidth: '320px', overflow: 'visible' }}>
														<div className="d-flex" onClick={(e) => e.stopPropagation()}>
															<div className="filter-vertical-tabs border-right" style={{ width: '100px', minHeight: '200px' }}>
																<button
																	type="button"
																	className={`d-block w-100 vertical-tab-item text-left ${this.state.userDetailsFilterTab === 'activity' ? 'active' : ''}`}
																	style={{ fontSize: '13px' }}
																	onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.setState({ userDetailsFilterTab: 'activity' }); }}
																>
																	Activity
																</button>
																<button
																	type="button"
																	className={`d-block w-100 vertical-tab-item ${this.state.userDetailsFilterTab === 'ip' ? 'active' : ''}`}
																	style={{ fontSize: '13px' }}
																	onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.setState({ userDetailsFilterTab: 'ip' }); }}
																>
																	IP
																</button>
																{isRansomwareAttack && (
																	<button
																		type="button"
																		className={`d-block w-100 vertical-tab-item text-left ${this.state.userDetailsFilterTab === 'file_type' ? 'active' : ''}`}
																		style={{ fontSize: '13px' }}
																		onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.setState({ userDetailsFilterTab: 'file_type' }); }}
																	>
																		File Type
																	</button>
																)}
															</div>
															<div className="filter-tab-content flex-grow-1" style={{ minHeight: '200px' }}>
																{this.state.userDetailsFilterTab === 'activity' && (
																	<>
																		<h6 className="mb-3 filter-heading">Select Activity</h6>
																		<div className="filter-content-wrapper">
																			<FormControl
																				as="select"
																				value={String(
																					(() => {
																						const d = this.state.filterDraftActivity ?? 'all';
																						if (d === 'all' || !activityFilterOptions.length) return d;
																						return activityFilterOptions.includes(d) ? d : 'all';
																					})()
																				)}
																				className="form-control"
																				onChange={(e) => this.setState({ filterDraftActivity: e.target.value || 'all' })}
																			>
																				<option value="all">All</option>
																				{activityFilterOptions.map((label) => (
																					label === 'Replied' && !this.state.isRepliedCampaign ? null : (
																						<option key={label} value={label}>{label}</option>
																					)
																				))}
																			</FormControl>
																		</div>
																	</>
																)}
																{this.state.userDetailsFilterTab === 'ip' && (
																	<>
																		<h6 className="mb-3 filter-heading">Select IPs</h6>
																		<div className="filter-content-wrapper">
																			<MultiSelect
																				key="filter-ip-multiselect"
																				className="multi-select borderRemove"
																				options={this.state.ips || []}
																				value={Array.isArray(this.state.filterDraftIps) ? this.state.filterDraftIps.filter((f) => (this.state.ips || []).some((o) => o.value === (f && f.value))) : []}
																				onChange={(selected) => this.setState({ filterDraftIps: selected || [] })}
																				overrideStrings={{ selectSomeItems: "Select IPs" }}
																				hasSelectAll={false}
																			/>
																		</div>
																	</>
																)}
																{isRansomwareAttack && this.state.userDetailsFilterTab === 'file_type' && (
																	<>
																		<h6 className="mb-3 filter-heading">Select File Type</h6>
																		<div className="filter-content-wrapper">
																			<FormControl
																				as="select"
																				className="form-control"
																				value={String(
																					(() => {
																						const d =
																							this.state.filterDraftFileType ?? "all";
																						if (
																							d === "all" ||
																							!FILE_TYPE_FILTER_OPTIONS.length
																						) {
																							return "all";
																						}
																						return FILE_TYPE_FILTER_OPTIONS.some(
																							(o) => o.value === d
																						)
																							? d
																							: "all";
																					})()
																				)}
																				onChange={(e) =>
																					this.setState({
																						filterDraftFileType:
																							e.target.value || "all",
																					})
																				}
																			>
																				<option value="all">All</option>
																				{FILE_TYPE_FILTER_OPTIONS.map((option) => (
																					<option
																						key={option.value}
																						value={option.value}
																					>
																						{option.label}
																					</option>
																				))}
																			</FormControl>
																		</div>
																	</>
																)}
															</div>
														</div>
														<div className="filter-panel-footer p-2 border-top d-flex justify-content-end">
															<Button variant="primary" size="md" onClick={this.applyUserDetailsFilters}>Apply</Button>
														</div>
													</Dropdown.Menu>
												</Dropdown>


											</div>
											)}
										</div>
									</div>
								</div>

								{this.state.key === "by-templates" ? (
									<div className="by-templates-wrap">
										{(() => {
											const myTemplates = this.state.myTemplates ?? [];
											if (!myTemplates.length) {
												return <div className="training-summary-empty">No templates assigned to this campaign.</div>;
											}
											return myTemplates.map((tpl, index) => {
												const imgSrc = tpl.thumbnailUrl ? tpl.thumbnailUrl : simulationandtrain;
												return (
													<div key={tpl.campaignTemplateId ?? index} className="by-templates-card">
														<img
															className="by-templates-thumb"
															src={imgSrc}
															alt={tpl.name}
															onError={(e) => { e.target.onerror = null; e.target.src = simulationandtrain; }}
														/>
														<div className="by-templates-info">
															<div className="by-templates-name">{tpl.name}</div>
															<span
																className="by-templates-preview-link"
																role="button"
																tabIndex={0}
																onClick={() => this.setState({ showPreview: true, campaignTemplateId: tpl.campaignTemplateId })}
															>
																Preview Template
															</span>
														</div>
														<div className="by-templates-stats">
															{getByTemplateStatFields(this.state.attackType, this.state.targetInteractionType, this.state.isAIbased, this.state.credentialHarvesting).map((stat) => {
																const meta = getOverviewIconMeta(stat.message, this.state.attackType);
																return (
																	<div key={stat.field} className={`by-templates-stat-box ${meta.colorClass}`}>
																		<div className="by-templates-stat-value">{tpl[stat.field] ?? 0}</div>
																		<div className="by-templates-stat-label">{meta.label}</div>
																	</div>
																);
															})}
														</div>
														<button
															type="button"
															className="by-templates-action-btn"
															aria-label="View template details"
															onClick={() => this.setState({ byTemplateModalOpen: true, byTemplateModalTemplate: tpl })}
														>
															<PiEye size={18} />
														</button>
													</div>
												);
											});
										})()}
									</div>
								) : (
									<>
										<div className="selected-filter mb-2 d-flex flex-wrap align-items-center gap-2">
											{this.state.statusFilter && this.state.statusFilter !== 'all' && (
												<Badge variant="secondary" className="badge-soft-primary-filter d-inline-flex align-items-center px-2 py-1">
													<span className="mr-1">Activity: {this.state.statusFilter}</span>
													<PiXThin
														className="cursor-pointer "
														onClick={(e) => { e.stopPropagation(); this.removeUserDetailsFilter('activity'); }}
														aria-label="Remove activity filter"
													/>
												</Badge>
											)}
											{Array.isArray(this.state.selectedIps) && this.state.selectedIps.map((ip) => (
												<Badge key={ip && ip.value} variant="secondary" className="badge-soft-primary-filter d-inline-flex align-items-center px-2 py-1">
													<span className="mr-1">IP: {ip && ip.label}</span>
													<PiXThin
														className="cursor-pointer"
														onClick={(e) => { e.stopPropagation(); this.removeUserDetailsFilter('ip', ip && ip.value); }}
														aria-label="Remove IP filter"
													/>
												</Badge>
											))}
											{isRansomwareAttack &&
												this.state.fileTypeFilter &&
												this.state.fileTypeFilter !== 'all' && (
													<Badge
														variant="secondary"
														className="badge-soft-primary-filter d-inline-flex align-items-center px-2 py-1"
													>
														<span className="mr-1">
															File Type: {this.getFileTypeFilterLabel(this.state.fileTypeFilter)}
														</span>
														<PiXThin
															className="cursor-pointer"
															onClick={(e) => {
																e.stopPropagation();
																this.removeUserDetailsFilter('fileType');
															}}
															aria-label="Remove file type filter"
														/>
													</Badge>
												)}
										</div>
										<div className="table-grey-header">
											<table className="table">
												<thead >
													<tr>
														<th>Name</th>
														<th>Designation</th>
														<th>Department</th>
														<th>Location</th>
														<th>Last Activity</th>
														{isRansomwareAttack && <th>Target OS</th>}
														<th>EVS</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													{this.state.results.length ? this.state.results.map((result) => {
														const target = result && result.target ? result.target : {};
														const first = (target.firstname || "").trim();
														const last = (target.lastname || "").trim();
														const initials = (first.charAt(0) + (last ? last.charAt(0) : first.charAt(1) || "")).toUpperCase() || "—";
														const displayName = [first, last].filter(Boolean).join(" ") || "—";
														const isPlaceholder = target.firstname === "_";
														return (
															<tr key={result.id || result.email} style={isPlaceholder ? { opacity: 0.5 } : {}}>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="user-initials-avatar">{initials}</div>
																		<div className="ml-2">
																			<div className="user-name-text">{displayName}</div>
																			<small className="user-email-text text-muted">{target.email || "—"}</small>
																		</div>
																	</div>
																</td>
																<td>{target.position || "—"}</td>
																<td>{target.department && target.department.name ? target.department.name : "—"}</td>
																<td>{target.location && target.location.name ? target.location.name : "—"}</td>
																<td>{this.renderUserActivityStatusBadge(result.status)}</td>
																{isRansomwareAttack && (
																	<td>
																		<Badge variant="primary" className="badge-soft-secondary">
																			{this.getResultFileTypeLabel(result)}
																		</Badge>
																	</td>
																)}
																<td>{(result.evsScore !== null && result.evsScore !== undefined) ? result.evsScore : "—"}</td>
																<td>
																	{!isPlaceholder && (
																		<a href="#" className="view-link" onClick={(e) => { e.preventDefault(); this.setState({ activityDrawerOpen: true, activityDrawerUser: result }); }}>View</a>
																	)}
																</td>
															</tr>
														);
													}) : (
														<tr>
															<td colSpan={userAnalyticsTableColSpan} className="text-center text-muted py-4">No data found</td>
														</tr>
													)}
												</tbody>
											</table>

										</div>

										<div className="pagination-Wrap">
											<div className="row">
												<div className="col-md-6">
													{!this.state.loading && (
														<Pagination
															itemClass="page-item"
															linkClass="page-link"
															activePage={this.state.activePage}
															itemsCountPerPage={this.state.limit}
															totalItemsCount={this.state.count}
															onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
														/>
													)}
												</div>
												<div className="col-md-6 text-right d-flex align-items-center footer-pg">
													<div className="w-100 pgCount">
														<p>
															{this.state.count ? `${(this.state.activePage - 1) * this.state.limit + 1}-${Math.min(this.state.activePage * this.state.limit, this.state.count)} of ${this.state.count} records` : "0 records"}
														</p>
													</div>
												</div>
											</div>
										</div>
									</>
								)}

							</>
						)}
						{this.state.activeAnalyticsTab === 'training-summary' && (
							<div className="training-summary-wrap">
								{this.state.trainingSummaryLoading ? (
									<div className="training-summary-empty">Loading training summary…</div>
								) : (this.state.trainingSummaryCourses || []).length === 0 ? (
									<div className="training-summary-empty">No training progress found yet for this campaign.</div>
								) : (
									this.state.trainingSummaryCourses.map((c) => (
										<div key={c.courseId} className="training-summary-card">
											<img className="training-summary-thumb" src={c.logo ? (this.state.trainingImageURL + c.logo) : simulationandtrain} alt="" onError={(e) => { e.target.onerror = null; e.target.src = simulationandtrain; }} />
											<div className="training-summary-info">
												<div className="training-summary-label">COURSE</div>
												<div className="training-summary-course-name">{c.name}</div>
												<div className="training-summary-progress">
													<div className="training-summary-progress-fill" style={{ width: `${c.completionRate || 0}%` }} />
												</div>
												<div className="training-summary-rate">{c.completionRate || 0}% Completion Rate</div>
											</div>
											<div className="training-summary-stats">
												<span className="training-summary-chip is-learners">Learners <b>{c.learners}</b></span>
												<span className="training-summary-chip is-notstarted">Not Started <b>{c.notStarted}</b></span>
												<span className="training-summary-chip is-inprogress">In Progress <b>{c.inProgress}</b></span>
												<span className="training-summary-chip is-completed">Completed <b>{c.completed}</b></span>
											</div>
											{!c.isPreLaunch && this.state.lmsUrl && (
												<button
												type="button"
												title="Open in TLMS"
												onClick={() => this.openTrainingSummary()}
												className="training-summary-open-btn"
												disabled={!(c.learners || c.notStarted || c.inProgress || c.completed)}
											>↗</button>
											)}
										</div>
									))
								)}
							</div>
						)}
						{this.state.activeAnalyticsTab === 'campaign-details' && (
							<div className="campaign-details-list-wrap">
								<ul className="campaign-details-list list-unstyled mb-0">
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Campaign Type:</span>
										<span className="campaign-details-value"><Badge variant="primary" className="badge-soft-primary">{this.state.simulationType}</Badge></span>
									</li>
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Created Date:</span>
										<span className="campaign-details-value">{getDateWithoutTime(this.state.createdAt)}</span>
									</li>
									{!(
										this.state.simulationIsScheduled === 0
									) && (
											<li className="campaign-details-list-item">
												<span className="campaign-details-label">Scheduled Date:</span>
												<span className="campaign-details-value">{getDate(this.state.scheduledAt)}</span>
											</li>
										)}
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Launch Date:</span>
										<span className="campaign-details-value">{getDate(this.state.launchDate)}</span>
									</li>
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Users:</span>
										<span className="campaign-details-value">{this.state.userCount}</span>
									</li>
									{this.state.followUpCondition !== null ? (
										<li className="campaign-details-list-item">
											<span className="campaign-details-label">Target Condition:</span>
											<span className="campaign-details-value"><Badge variant="primary" className="badge-soft-secondary">{this.state.followUpCondition}</Badge></span>
										</li>
									) : (
										<li className="campaign-details-list-item">
											<span className="campaign-details-label">Target Groups:</span>
											<span className="campaign-details-value"><Badge variant="primary" className="badge-soft-secondary">{names}</Badge></span>
										</li>
									)}
									{this.state.parentSimulationId &&
										this.state.details?.campaign?.simulations.filter(simulation => simulation.id == this.state.parentSimulationId).map(simulation => (
											<li className="campaign-details-list-item">
												<span className="campaign-details-label">Parent Campaign:</span>
												<span className="campaign-details-value"><Badge variant="primary" className="badge-soft-secondary">{simulation.name}</Badge></span>
											</li>
										))

									}
									{(this.state.attackType !== "Attachment" && this.state.simulationType === "Simulation Attack + Training") && (
										<li className="campaign-details-list-item">
											<span className="campaign-details-label">Instant Awareness:</span>
											<span
												className="campaign-details-value"
												style={{
													color: this.state.instantAwareness === true ? "green" : this.state.instantAwareness === false ? "red" : "#6c757d"
												}}
											>
												{this.state.instantAwareness === true ? "On" : this.state.instantAwareness === false ? "Off" : "—"}
											</span>
										</li>
									)}
									{
										this.state.attackType !== "Smishing" &&
										this.state.attackType !== "Telegram" &&
										!(
											this.state.attackType === "Vishing" &&
											this.state.targetInteractionType === "outbound"
										) &&
										(this.state.attackType !== "WhatsApp" ||
											(this.state.targetInteractionType === "inbound" && this.state.isAIbased)) && (
											<li className="campaign-details-list-item">
												<span className="campaign-details-label">User Reply Configuration:</span>
												<span className="campaign-details-value" style={{ color: this.state.userReplyConfiguration ? "green" : "red" }}>{this.state.userReplyConfiguration ? "On" : "Off"}</span>
											</li>
										)
									}

									{
										this.state.attackType !== "Ransomware" &&
										this.state.attackType !== "Attachment" &&
										!(
											this.state.attackType === "Vishing" &&
											(this.state.targetInteractionType) === "outbound"
										) && (
											<li className="campaign-details-list-item">
												<span className="campaign-details-label">Credential Harvesting:</span>
												<span className="campaign-details-value" style={{ color: this.state.credentialHarvesting ? "green" : "red" }}>{this.state.credentialHarvesting ? "On" : "Off"}</span>
											</li>
										)
									}

									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Campaign Duration:</span>
										<span className="campaign-details-value">
											{formatCampaignDurationForEdit(
												this.state.details,
												this.state.completesOn
											)}
										</span>
									</li>
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Campaign Expiry:</span>
										{(() => {
											const campaignExpiryLabel = formatCampaignExpiryForEdit(
												this.state.details,
												this.state.completesOn
											);
											return (
												<span
													className="campaign-details-value"
													style={
														campaignExpiryLabel !== "—"
															? { color: "red" }
															: undefined
													}
												>
													{campaignExpiryLabel}
												</span>
											);
										})()}
									</li>
									<li className="campaign-details-list-item">
										<span className="campaign-details-label">Templates:</span>
										<span className="campaign-details-value template-count">
											{(() => {
												const assignTemplates = this.state.details?.assign_simulation_templates ?? [];
												if (!assignTemplates.length) return "—";
												return assignTemplates.map((assign, index) => {
													const ct = assign?.campaign_template;
													if (!ct) return null;
													let templatePath = ct.templatePath;
													const imgSrc =
														ct.template && ct.template.thumbnail != null
															? templatePath
															: simulationandtrain;
													return (
														<span key={assign.campaignTemplateId ?? index} className="d-inline-flex align-items-center template-details-wrap">
															<span style={{ cursor: "pointer" }} className="mr-1 template-image" onClick={() => this.setState({ showPreview: true, campaignTemplateId: ct.id })}><img src={imgSrc} alt={ct.name} style={{ width: "100%", height: "auto", display: "block" }} /></span>
															<span className="template-name">{ct.name}</span>
														</span>
													);
												});
											})()}
										</span>
									</li>
								</ul>
							</div>
						)}
					</div>
				</div>
				<DetailModal
					groupName={this.state.groupName}
					details={this.state.details}
					detailModal={this.state.detailModal}
					detailHandle={e => this.setState({ detailModal: false })}
				></DetailModal>
				{this.state.showPreview ?
					<CampaignPreview
						load={this.load}
						fromCampaign={true}
						nextPath={this.nextPath}
						show={this.state.showPreview}
						campaignTemplateId={this.state.campaignTemplateId}
						campaignType={this.state.campaignType}
						dimCredentialHarvestingSections={true}
						credentialHarvestingOverride={this.state.credentialHarvesting}
						handleModal={() => this.setState({ showPreview: false })}
					></CampaignPreview> : ''
				}
				{!isFromTestCampaign && (
					<FollowUpCampaignModal
						showModal={this.state.showFollowUpModal}
						onClose={() => this.setState({ showFollowUpModal: false })}
						campaignId={this.state.campaignId}
						simulationId={this.state.simulationId}
						attackType={this.state.attackType}
						targetInteractionType={this.state.targetInteractionType}
						isAIbased={this.state.isAIbased}
						simulationType={this.state.simulationType}
						groupIds={this.state.groupIds}
						credentialHarvesting={this.state.credentialHarvesting}
						onSuccess={this.handleFollowUpSuccess}
						simulations={this.state.details?.campaign?.simulations}
					/>
				)}
				<ActivityDrawer
					show={this.state.activityDrawerOpen}
					onClose={() => this.setState({ activityDrawerOpen: false, activityDrawerUser: null })}
					user={this.state.activityDrawerUser}
					attackType={this.state.attackType}
				/>
				<ByTemplateModal
					show={this.state.byTemplateModalOpen}
					onClose={() => this.setState({ byTemplateModalOpen: false, byTemplateModalTemplate: null })}
					template={this.state.byTemplateModalTemplate}
					campaignId={this.state.campaignId}
					simulationId={this.state.simulationId}
					attackType={this.state.attackType}
					simulationType={this.state.simulationType}
				/>
				{this.state.headerRefreshLoading ? <Loader /> : null}
				{this.state.followUpTabLoading ? <Loader /> : null}
			</div>
		);
	}
}
